
      // Own deferred attributes avoid CheckoutChamp eagerly restoring these URLs.
      window.hlpLoadVideo = function (video) {
        if (!video) return;
        var poster = video.getAttribute('data-hlp-poster');
        if (poster) {
          video.poster = poster;
          video.removeAttribute('data-hlp-poster');
        }
        var src = video.getAttribute('data-hlp-src') || video.getAttribute('data-src');
        if (src && !video.getAttribute('src')) video.src = src;
        video.removeAttribute('data-hlp-src');
      };
    
;

            // ============ HYBRID LP WIRING ============
            // Mirrors the production PDP: selections build a
            // localStorage['productInfo'] = "?products=<variantId>:1;<gift>:1;..."
            // string, and the fk-addToCartBtn fires CheckoutChamp's route()/callMethod()
            // to add-to-cart and advance the funnel straight to the checkout step.
            (function () {
              // In local/Cloudflare preview these CKC platform fns don't exist — define
              // safe no-ops ONLY off the live domain so QA clicks never throw. Never
              // overrides the real functions in production.
              var IS_PREVIEW = /localhost|127\.0\.0\.1|\.pages\.dev$/i.test(location.hostname);
              if (IS_PREVIEW) {
                window.callMethod = window.callMethod || function (e) { e && e.preventDefault && e.preventDefault(); };
                window.route = window.route || function (e) { e && e.preventDefault && e.preventDefault(); };
                window.linkMethod = window.linkMethod || function (e) { e && e.preventDefault && e.preventDefault(); };
              }

              var CDN = 'https://cdn.shopify.com/s/files/1/0433/0510/7612/files/';
              var VID = 'https://cdn.shopify.com/videos/c/o/v/';

      // Product Variant Mapping
                                                    window.productVariants = {
                                                       'product-1': {
                                                          displayText: "1 PuppyPad",
                                                          offerKey: '1 PuppyPad',
                                                          gifts: ["625:1;626:1;627:1"],
                                                          variants: {
                                                             'Small-Gray': '629.47:china',
                                                             'Small-White': '629.38:china',
                                                             'Medium-Gray': '629.48:china',
                                                             'Medium-White': '629.39:china',
                                                             'Large-Gray': '629.49:china',
                                                             'Large-White': '629.40:china',
                											'Small-Beige': '629.35:china',
                'Medium-Beige': '629.36:china',
                'Large-Beige': '629.37:china',
                'Small-Brave Beige': '629.309:china',
                'Medium-Brave Beige': '629.310:china',
                'Large-Brave Beige': '629.308:china'
                                                          }
                                                       },
                                                       'product-2': {
                                                          displayText: "Buy 3 Get 3 Free",
                                                          offerKey: 'Buy 3 Get 3 Free',
                                                          gifts: ["625:1;626:1;627:1"],
                                                          variants: {
                                                             'Small-Gray': '630.214:china',
                                                             'Small-White': '630.285:china',
                                                             'Medium-Gray': '630.215:china',
                                                             'Medium-White': '630.286:china',
                                                             'Large-Gray': '630.216:china',
                                                             'Large-White': '630.287:china',
                											'Small-Beige': '630.217:china',
                'Medium-Beige': '630.218:china',
                'Large-Beige': '630.219:china',
                'Small-Brave Beige': '630.297:china',
                'Medium-Brave Beige': '630.298:china',
                'Large-Brave Beige': '630.299:china'
                                                          }
                                                       },
                                                       'product-3': {
                                                          displayText: "Buy 2 Get 1 Free",
                                                          offerKey: 'Buy 2 Get 1 Free',
                                                          gifts: ["625:1;626:1;627:1"],
                                                          variants: {
                                                             'Small-Gray': '631.208:china',
                                                             'Small-White': '631.282:china',
                                                             'Medium-Gray': '631.209:china',
                                                             'Medium-White': '631.283:china',
                                                             'Large-Gray': '631.210:china',
                                                             'Large-White': '631.284:china',
                											'Small-Beige': '631.211:china',
                'Medium-Beige': '631.212:china',
                'Large-Beige': '631.213:china',

                'Small-Brave Beige': '631.288:china',
                'Medium-Brave Beige': '631.289:china',
                'Large-Brave Beige': '631.290:china'
                                                          }
                                                       }
                                                    };

              // Display metadata for the hybrid offer rows (IDs above stay PDP-verbatim)
              var OFFER_META = {
                'product-2': { title: 'Buy 3 Get 3 Free', price: 149 },
                'product-3': { title: 'Buy 2 Get 1 Free', price: 99 },
                'product-1': { title: '1 PuppyPad', price: 50 }
              };

              // Offer card images per colour (same CDN assets as the PDP)
              var offerImages = {
                'Gray': {
                  'product-1': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gray-1Pad.png?v=1788972203',
                  'product-2': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gray-6Pads.png?v=1788972203',
                  'product-3': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gray-3Pads.png?v=1788972203'
                },
                'Beige': {
                  'product-1': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-1Pad.png?v=1788972190',
                  'product-2': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-6Pads.png?v=1788972190',
                  'product-3': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-3Pads.png?v=1788972191'
                },
                'Brave Beige': {
                  'product-1': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-1Pad.png?v=1788972190',
                  'product-2': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-6Pads.png?v=1788972190',
                  'product-3': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-3Pads.png?v=1788972191'
                },
                'White': {
                  'product-1': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/White-1Pad.png?v=1788972222',
                  'product-2': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/White-6Pads.png?v=1788972222',
                  'product-3': 'https://cdn.shopify.com/s/files/1/0838/3797/6811/files/White-3Pads.png?v=1788972222'
                }
              };

              var sel = { size: 'Large', color: 'Gray', offer: 'product-2' };

              function fmt(n) { return n.toLocaleString('en-US'); }
              function qs(s, r) { return (r || document).querySelector(s); }
              function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
              function setText(id, v) { var el = document.getElementById(id); if (el && el.textContent !== String(v)) el.textContent = v; }
              var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

              // Availability comes from the same catalogue used for the cart, including geo updates.
              var stockOptions;
              function isSoldOut(size, color, offer) {
                var item = productVariants[offer];
                var id = item && item.variants[size + '-' + color];
                return !id || id.split('|')[0].split(':').indexOf('outofstock') > -1;
              }
              function renderAvailability() {
                var soldOut = isSoldOut(sel.size, sel.color, sel.offer);
                if (!stockOptions) {
                  stockOptions = qsa('.ob2-size, .ob2-color').map(function (el) {
                    var badge = document.createElement('span');
                    badge.className = 'hlp-stock-badge';
                    badge.textContent = 'Sold out';
                    badge.hidden = true;
                    el.appendChild(badge);
                    return { el: el, badge: badge };
                  });
                }
                stockOptions.forEach(function (option) {
                  var size = option.el.getAttribute('data-size') || sel.size;
                  var color = option.el.getAttribute('data-color') || sel.color;
                  var unavailable = isSoldOut(size, color, sel.offer);
                  option.el.classList.toggle('is-sold-out', unavailable);
                  option.badge.hidden = !unavailable;
                });
                var atc = document.getElementById('addToCartBtn');
                if (atc) {
                  atc.disabled = soldOut;
                  atc.setAttribute('aria-disabled', String(soldOut));
                  atc.dataset.outOfStock = String(soldOut);
                  if (soldOut) atc.classList.remove('is-pulse');
                }
                var notice = document.getElementById('hlpStockNotice');
                if (notice) {
                  setText('hlpStockNotice', soldOut ? sel.color + ' in ' + sel.size + ' is sold out. Please choose another size or color.' : '');
                  notice.hidden = !soldOut;
                }
                if (soldOut) setText('hlpAtcLabel', 'Sold out');
                var price = document.getElementById('hlpAtcPrice');
                if (price) price.hidden = soldOut;
                var item = productVariants[sel.offer];
                var id = item && item.variants[sel.size + '-' + sel.color];
                var isChina = id && id.split(':').indexOf('china') > -1;
                var shipping = document.getElementById('chinaShippingDisclaimer');
                if (shipping) shipping.style.display = isChina && !soldOut ? 'block' : 'none';
                return soldOut;
              }

              // ---- productInfo (kept global: the geo script calls it after swapping IDs) ----
              window.updateProductInfo = function () {
                renderLabels();
                if (renderAvailability()) {
                  try { localStorage.removeItem('productInfo'); } catch (e) {}
                  return null;
                }
                var variant = productVariants[sel.offer];
                if (!variant) return;
                var key = sel.size + '-' + sel.color;
                var id = variant.variants[key];
                if (!id) return;
                var clean = id.split(':')[0];
                var products = '?products=' + clean + ':1';
                if (variant.gifts && variant.gifts.length > 0) {
                  variant.gifts.forEach(function (giftID) { products += ';' + giftID + ':1'; });
                }
                try { localStorage.setItem('productInfo', products); } catch (e) {}
                return products;
              };

              function persistSelections() {
                try {
                  localStorage.setItem('selectedSize', sel.size);
                  localStorage.setItem('selectedColor', sel.color);
                  localStorage.setItem('puppypadSelections', JSON.stringify({ size: sel.size, color: sel.color }));
                  sessionStorage.setItem('puppypadUIState', JSON.stringify({ size: sel.size, color: sel.color, offer: sel.offer }));
                } catch (e) {}
              }

              // ---- buy-box labels ----
              function renderLabels() {
                var meta = OFFER_META[sel.offer];
                setText('hlpSizeLabel', sel.size);
                setText('hlpColorLabel', sel.color);
                setText('hlpOfferLabel', meta.title);
                // CKC auto-converts on-page prices to the visitor's currency, so
                // rebuilding this label from OFFER_META would flash it back to USD
                // on every selection change. Mirror the PDP fix: read the selected
                // card's displayed price (.ob2-offer-price — never the compare
                // price or savings tag), which stays converted; fall back to the
                // USD map only if the card text is ever missing.
                var cardPrice = qs('.ob2-offer.is-on .ob2-offer-price');
                var shown = cardPrice && cardPrice.textContent.trim();
                setText('hlpAtcLabel', 'Add To Cart · ' + (shown || '$' + meta.price));
              }

              // ---- offer card images follow the selected colour ----
              function updateOfferImages() {
                var imgs = offerImages[sel.color];
                if (!imgs) return;
                qsa('.ob2-offer').forEach(function (el) {
                  var key = el.getAttribute('data-offer');
                  var img = el.querySelector('.ob2-offer-image');
                  if (img && imgs[key]) {
                    var src = sized(imgs[key], 360);
                    if (img.getAttribute('src') !== src) img.src = src;
                    // CKC's restore/watchdog must keep the selected colour.
                    img.setAttribute('data-src', src);
                  }
                });
              }

              // ---- offer info modal ----
              function setupModal(modalId, openBtnId, closeBtnId, onOpen) {
                var modal = document.getElementById(modalId);
                var openBtn = document.getElementById(openBtnId);
                var closeBtn = document.getElementById(closeBtnId);
                if (!modal) return;
                var scrollPos = 0;
                function open() {
                  scrollPos = window.pageYOffset;
                  modal.classList.add('show');
                  document.body.style.position = 'fixed';
                  document.body.style.top = -scrollPos + 'px';
                  document.body.style.width = '100%';
                  document.body.style.overflow = 'hidden';
                  if (onOpen) onOpen();
                }
                function close() {
                  modal.classList.remove('show');
                  document.body.style.position = '';
                  document.body.style.top = '';
                  document.body.style.width = '';
                  document.body.style.overflow = '';
                  window.scrollTo(0, scrollPos);
                }
                if (openBtn) openBtn.addEventListener('click', open);
                if (closeBtn) closeBtn.addEventListener('click', close);
                modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
              }

              // ---- review carousel inside the offer info modal ----
              var reviewTrack = document.getElementById('hlpReviewTrack');
              var reviewIndex = 0;
              var reviewSlides = reviewTrack ? Array.from(reviewTrack.children) : [];
              function sizeOfferSlides() {
                if (!reviewTrack) return;
                var wrap = reviewTrack.parentElement;
                var w = wrap.getBoundingClientRect().width || wrap.offsetWidth;
                if (!w) return;
                reviewSlides.forEach(function (slide) { slide.style.flex = '0 0 ' + w + 'px'; slide.style.width = w + 'px'; });
                reviewTrack.style.width = (w * reviewSlides.length) + 'px';
                reviewTrack.style.transform = 'translateX(-' + (reviewIndex * w) + 'px)';
              }
              function moveOffer(delta) {
                if (!reviewTrack) return;
                reviewIndex = (reviewIndex + delta + reviewSlides.length) % reviewSlides.length;
                sizeOfferSlides();
              }

              // Re-render everything that depends on the current size/color/offer
              // selection, including the productInfo string and shipping notice.
              function update() {
                updateOfferImages();
                window.updateProductInfo();
              }

              // ---- ATC pulse ----
              var pulseT;
              function bump() {
                var atc = document.getElementById('addToCartBtn');
                if (!atc || atc.disabled || REDUCED) return;
                clearTimeout(pulseT);
                atc.classList.remove('is-pulse');
                void atc.offsetWidth;
                atc.classList.add('is-pulse');
                pulseT = setTimeout(function () { atc.classList.remove('is-pulse'); }, 2400);
              }

              // ---- smooth scroll ----
              function scrollToEl(id) {
                var el = document.getElementById(id);
                if (!el) return;
                el.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
              }

              // ---- gallery ----
              // Slide 1 ({ fit: true }) shows the pad on the floor and follows BOTH
              // the selected colour and size via the FIT matrix. The fabric close-up
              // follows colour only. The machine-washable / cost / shredded stills
              // are fixed Brave Beige brand shots. Videos never change.
              var FIT = {
                'Gray': { Small: CDN + 'grey-gallery-fit-small.webp?v=1786973644', Medium: CDN + 'grey-gallery-fit-medium.webp?v=1786973644', Large: CDN + 'grey-gallery-fit-large.webp?v=1786961541' },
                'Beige': { Small: CDN + 'beige-gallery-fit-small_48a79424-575f-421b-8f73-6f70f6a737d8.webp?v=1786974512', Medium: CDN + 'beige-gallery-fit-medium.webp?v=1786974494', Large: CDN + 'beige-gallery-fit-large.webp?v=1786961542' },
                'Brave Beige': { Small: CDN + 'brave-beige-gallery-fit-small.webp?v=1786961542', Medium: CDN + 'brave-beige-gallery-fit-medium.webp?v=1786975783', Large: CDN + 'brave-beige-gallery-fit-large.webp?v=1786961542' },
                'White': { Small: CDN + 'white-gallery-fit-small.webp?v=1786961542', Medium: CDN + 'white-gallery-fit-medium.webp?v=1786961542', Large: CDN + 'white-gallery-fit-large.webp?v=1786961542' }
              };
              var GALLERY = [
                { fit: true },
                { video: true, vsrc: VID + '9384c28f91c146029aaa0bcfc6d39eff.mp4', poster: CDN + 'Gallery_Hero_Poster.webp?v=1785849859' },
                { colorSrc: { Gray: CDN + 'Gallery_Fabric_Macro.webp?v=1785538886', Beige: CDN + 'beige-gallery-fabric-macro_jpeg.webp?v=1786961837', 'Brave Beige': CDN + 'brave-beige-gallery-fabric-macro_jpeg.webp?v=1786961837', White: CDN + 'white-gallery-fabric-macro_jpeg.webp?v=1786961837' } },
                { video: true, vsrc: VID + '7a75f9ac824a4facba4ba3d3d11f330e.mp4', poster: CDN + 'Gallery_Absorption_Poster.webp?v=1785849859' },
                { src: CDN + 'brave-beige-gallery-machine-washable.webp?v=1786961540' },
                { video: true, vsrc: VID + '7f2c7a9b84824bf68d7ec54b8f7b32c6.mp4', poster: CDN + 'Gallery_Scent_Poster.webp?v=1785849859', caption: true },
                { video: true, vsrc: VID + 'bef474c48bdd4e1abe5203409f2c7fa6.mp4', poster: CDN + 'Gallery_Flip_Test_Poster.webp?v=1785540332' },
                { src: CDN + 'gallery-cost-brave-beige.webp?v=1786961542' },
                { src: CDN + 'Brave_Beige_Pad_Shredded_vs_Intact.webp?v=1786961542' },
                { video: true, vsrc: VID + '8a81f0cca42d4e68bb665aac187ab0c4.mp4', poster: CDN + 'Gallery_Anti_Slip_Poster.webp?v=1785849859' },
                { src: CDN + 'Product-IMG-2-General.webp?v=1754698762' },
                { src: CDN + 'Product-IMG-6-General.webp?v=1754417741' },
                { video: true, vsrc: VID + '2dcd744ad0ea449ab28c72a8fa382176.mp4', poster: CDN + '90_Days_Guarantee_Poster.webp?v=1785870042' }
              ];
              var gIdx = 0, fadeT;

              function slideSrc(g) {
                if (g.fit) { var m = FIT[sel.color] || FIT.Gray; return m[sel.size] || m.Large; }
                if (g.colorSrc) return g.colorSrc[sel.color] || g.colorSrc.Gray;
                return g.src || g.poster || '';
              }

              // Shopify CDN resize: the gallery masters are ~2048px / ~500KB — far
              // more than the stage (≤640px column) or the 44-105px thumbs ever
              // show. STAGE_W feeds the stage, swipe preview and pre-warm (one
              // shared cache entry); THUMB_W keeps thumb tiles to a few KB each.
              // Phones never display the stage wider than ~430 CSS px, so a 1000px
              // variant covers 2-3x DPR there; desktop keeps 1400. One bucket per
              // session keeps every swap and pre-warm hitting the same CDN cache.
              var STAGE_W = (window.innerWidth || 1024) <= 520 ? 1000 : 1400, THUMB_W = 200;
              function sized(u, w) {
                if (!u) return u;
                if (/([?&])width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
                return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
              }

              // Reuse pending image requests, and give an actual selection priority
              // over speculative warming. Small previews also back the full image
              // so a fast swipe does not uncover the stage's empty background.
              var galleryImages = {};
              function warmImage(src, priority) {
                if (!src) return;
                var im = galleryImages[src];
                if (!im) {
                  im = new Image();
                  im.decoding = 'async';
                  im.fetchPriority = priority || 'low';
                  galleryImages[src] = im;
                  im.onerror = function () { delete galleryImages[src]; };
                  im.src = src;
                } else if (priority === 'high') im.fetchPriority = 'high';
              }
              function galleryBackground(g) {
                var src = slideSrc(g);
                warmImage(sized(src, STAGE_W), 'high');
                return 'url("' + sized(src, STAGE_W) + '"), url("' + sized(src, THUMB_W) + '")';
              }
              function warmSelectionPreviews() {
                Object.keys(FIT).forEach(function (color) {
                  warmImage(sized(FIT[color][sel.size], THUMB_W));
                });
                Object.keys(FIT[sel.color]).forEach(function (size) {
                  warmImage(sized(FIT[sel.color][size], THUMB_W));
                });
              }

              // Start the selected gallery near the buy box. Warm a specific
              // variant on pointer/focus intent instead of fetching all 16 large
              // colour/size photos at once (including ones never selected).
              var galleryBooted = false;
              function bootGallery() {
                if (galleryBooted) return;
                galleryBooted = true;
                renderStage();
                // Small bundle images should be ready before the shopper taps a
                // colour. These are bounded 360px assets, not gallery originals.
                function warmOffers() {
                  var sizeChart = qs('#hlpSizePanel img[data-hlp-src]');
                  if (sizeChart) warmImage(sizeChart.getAttribute('data-hlp-src'));
                  if (giftData) giftData.forEach(function (gift) { warmImage(gift.image); });
                  Object.keys(offerImages).forEach(function (color) {
                    Object.keys(offerImages[color]).forEach(function (offer) {
                      warmImage(sized(offerImages[color][offer], 360));
                    });
                  });
                }
                if ('requestIdleCallback' in window) requestIdleCallback(warmOffers);
                else setTimeout(warmOffers, 600);
              }

              (function () {
                function warmIntent(e) {
                  var opt = e.target.closest('[data-color], [data-size]');
                  if (!opt) return;
                  var color = opt.getAttribute('data-color') || sel.color;
                  var size = opt.getAttribute('data-size') || sel.size;
                  var current = GALLERY[gIdx];
                  var src = current.colorSrc && opt.hasAttribute('data-color')
                    ? current.colorSrc[color] : FIT[color] && FIT[color][size];
                  src = sized(src, STAGE_W);
                  warmImage(src);
                }
                var arm = function () {
                  var bb = document.getElementById('buybox');
                  if (bb) ['pointerover', 'focusin', 'pointerdown'].forEach(function (event) {
                    bb.addEventListener(event, warmIntent, { passive: true });
                  });
                  if (bb && 'IntersectionObserver' in window) {
                    new IntersectionObserver(function (entries, obs) {
                      if (entries[0].isIntersecting) { bootGallery(); obs.disconnect(); }
                    }, { rootMargin: '1200px 0px' }).observe(bb);
                  } else bootGallery();
                };
                if (document.readyState !== 'loading') arm();
                else document.addEventListener('DOMContentLoaded', arm);
              })();

              function renderStage() {
                var cur = GALLERY[gIdx];
                var img = document.getElementById('obStage');
                var vid = document.getElementById('obStageVid');
                var cap = document.getElementById('obCaption');
                var banner = document.getElementById('giftBanner');
                if (cur.video) {
                  if (img) img.style.display = 'none';
                  if (vid) {
                    vid.style.display = 'block';
                    // the multi-clip hero loop has pillarboxed segments — zoom past
                    // the baked-in bars whenever the stage plays that file
                    vid.classList.toggle('hlp-zoomvid', cur.vsrc.indexOf('c82df8c5') > -1);
                    var poster = cur.poster ? sized(cur.poster, STAGE_W) : '';
                    if (vid.getAttribute('poster') !== poster) { if (poster) vid.setAttribute('poster', poster); else vid.removeAttribute('poster'); }
                    if (vid.getAttribute('src') !== cur.vsrc) {
                      vid.setAttribute('src', cur.vsrc);
                      try { vid.load(); } catch (e) {}
                    }
                    var p = vid.play(); if (p && p.catch) p.catch(function () {});
                  }
                } else {
                  if (vid) { vid.style.display = 'none'; if (!vid.paused) vid.pause(); }
                  if (img) {
                    img.style.display = 'block';
                    img.style.backgroundImage = galleryBackground(cur);
                    img.setAttribute('aria-label', cur.fit ? 'PuppyPad — ' + sel.size + ', ' + sel.color : cur.colorSrc ? 'PuppyPad — ' + sel.color + ' fabric close-up' : 'PuppyPad');
                  }
                }
                if (cap) cap.style.display = cur.caption ? 'flex' : 'none';
                if (banner) banner.classList.toggle('visible', gIdx === 0);
                var badge = document.getElementById('obVariantBadge');
                if (badge) {
                  // fit slide: "Large Beige" · fabric close-up: "Beige PuppyPad"
                  badge.textContent = cur.fit ? sel.size + ' ' + sel.color : sel.color + ' PuppyPad';
                  badge.style.display = (cur.fit || cur.colorSrc) ? 'block' : 'none';
                }
                setText('obCount', (gIdx + 1) + ' / ' + GALLERY.length);
                renderThumbs();
                warmSelectionPreviews();
              }

              function renderThumbs() {
                var wrap = document.getElementById('obThumbs');
                if (!wrap) return;
                var win = 6;
                var start = Math.max(0, Math.min(GALLERY.length - win, gIdx - Math.floor(win / 2) + 1));
                var focusedSlide = wrap.contains(document.activeElement)
                  ? document.activeElement.getAttribute('data-slide') : null;
                // Keep the same buttons so arrow navigation does not rebuild the
                // thumbnail DOM or discard keyboard focus on every slide.
                for (var k = start; k < start + win && k < GALLERY.length; k++) {
                  (function (idx) {
                    var slot = idx - start;
                    var b = wrap.children[slot];
                    if (!b) {
                      b = document.createElement('button');
                      b.type = 'button';
                      var tile = document.createElement('img');
                      tile.alt = '';
                      tile.decoding = 'async';
                      tile.className = 'fk-disable-lazy';
                      b.appendChild(tile);
                      b.addEventListener('click', function () { setSlide(Number(b.getAttribute('data-slide'))); });
                      wrap.appendChild(b);
                    }
                    b.setAttribute('data-slide', idx);
                    b.setAttribute('aria-label', 'View slide ' + (idx + 1));
                    b.setAttribute('aria-pressed', idx === gIdx ? 'true' : 'false');
                    b.className = 'ob2-thumb' + (idx === gIdx ? ' is-on' : '');
                    var im = b.firstElementChild;
                    var src = sized(slideSrc(GALLERY[idx]), THUMB_W);
                    if (im.getAttribute('src') !== src) im.src = src;
                  })(k);
                }
                if (focusedSlide !== null) {
                  var focused = wrap.querySelector('[data-slide="' + focusedSlide + '"]');
                  if (focused && focused !== document.activeElement) focused.focus({ preventScroll: true });
                }
              }

              function setSlide(i) {
                var img = document.getElementById('obStage');
                var target = ((i % GALLERY.length) + GALLERY.length) % GALLERY.length;
                var immediate = REDUCED || GALLERY[gIdx].video || GALLERY[target].video;
                clearTimeout(fadeT);
                // Advance state immediately: a second quick Next tap must count.
                gIdx = target;
                if (immediate) {
                  if (img) img.style.opacity = 1;
                  renderStage(); return;
                }
                warmImage(sized(slideSrc(GALLERY[target]), STAGE_W), 'high');
                if (img) img.style.opacity = 0;
                fadeT = setTimeout(function () {
                  renderStage();
                  if (img) img.style.opacity = 1;
                }, 150);
              }

              // ---- scarcity (design-computed batch counter) ----
              function scarcity() {
                var alloc = 20000;
                var now = new Date(), y = now.getFullYear(), m = now.getMonth(), day = now.getDate();
                var dim = new Date(y, m + 1, 0).getDate();
                var t = dim > 1 ? (day - 1) / (dim - 1) : 1;
                var pct = Math.min(97, Math.round(34 + 62 * Math.pow(t, 0.82)));
                var names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                return {
                  alloc: alloc,
                  sold: Math.round(alloc * pct / 100 / 6) * 6,
                  pct: pct,
                  thisMonth: names[m],
                  prevMonth: names[(m + 11) % 12],
                  prevSold: 15000,
                  todayStr: names[m] + ' ' + day + ', ' + y
                };
              }
              var soldNow = 0, countT, tickT, flashT;

              function renderScarcity(flash) {
                var sc = scarcity();
                var shown = soldNow > 0 ? Math.min(sc.alloc, soldNow) : sc.sold;
                var pctNow = Math.round(shown / sc.alloc * 100);
                setText('hlpPct', pctNow + '%');
                setText('hlpPrevMonth', sc.prevMonth);
                setText('hlpPrevSold', fmt(sc.prevSold));
                setText('hlpThisMonth', sc.thisMonth);
                setText('hlpSold', fmt(shown));
                setText('hlpAlloc', fmt(sc.alloc));
                setText('hlpToday', sc.todayStr);
                var bar = document.getElementById('hlpBar');
                if (bar) bar.style.transform = 'scaleX(' + (pctNow / 100) + ')';
                var row = document.getElementById('hlpSoldRow');
                if (row) row.classList.toggle('is-flash', !!flash);
              }

              function countUp() {
                var target = scarcity().sold;
                if (REDUCED) { soldNow = target; renderScarcity(false); return; }
                var from = Math.round(target * 0.92), dur = 1400, t0 = Date.now();
                soldNow = from; renderScarcity(false);
                clearInterval(countT);
                countT = setInterval(function () {
                  var k = Math.min(1, (Date.now() - t0) / dur);
                  var eased = 1 - Math.pow(1 - k, 3);
                  soldNow = Math.round(from + (target - from) * eased);
                  renderScarcity(false);
                  if (k >= 1) clearInterval(countT);
                }, 40);
              }

              function queueTick() {
                clearTimeout(tickT);
                var wait = 14000 + Math.round(Math.random() * 20000);
                tickT = setTimeout(function () {
                  var sc = scarcity();
                  var ceiling = Math.min(sc.alloc - 8, sc.sold + Math.round(sc.alloc * 0.006));
                  var step = 2 + Math.floor(Math.random() * 5);
                  soldNow = Math.min(ceiling, (soldNow || sc.sold) + step);
                  renderScarcity(true);
                  clearTimeout(flashT);
                  flashT = setTimeout(function () { renderScarcity(false); }, 1400);
                  queueTick();
                }, wait);
              }

              // ---- Trustpilot wall ----
              var TPREVIEWS;
              function getReviews() {
                if (TPREVIEWS) return TPREVIEWS;
                return TPREVIEWS = [
            { name: 'Slue', where: 'US', date: 'Jun 6, 2026', tag: 'service', title: 'Outstanding Customer Service and Great Product', body: 'After my neighbor gave me one of these to try, I decided to order 6 more. I ordered the gray ones which were different from the one she had given me. When a customer service rep reached out to see how I liked the product, I asked about the difference and was told I had an updated version which works the same. I told her I liked the original version better and wish I had known. She said they would send me six more of the original since what I got was not what I expected. Unbelievable! My chihuahua is 19 with kidney disease. He\'s also blind and deaf. He can no longer navigate the dog doors in time to get out to potty. These pads are a game changer. He can easily find them and knows where to go. They wash up nicely and I\'m not filling the trash will disposable pads. They also stay put due to the rubber backing unlike the disposable pads which slide around on the floor. Since I place more value on customer service, I would definitely recommend purchasing from this small company. They have a great product and they stand behind it.' },
            { name: 'Leanne', where: 'US', date: 'Feb 9, 2026', tag: 'senior', title: 'You can teach an old dog new tricks', body: 'You can teach an old dog new tricks, at least with PuppyPad you can. I have a 14 year old Wheaton that can no longer make it through the night. I tried the disposable dog pads but she ignored them and urinated next to them. She used the PuppyPad the first night I put it near her bed. I can now sleep through the night :)' },
            { name: 'Jax', where: 'US', date: 'Jan 3, 2026', tag: 'senior', title: 'They really do work!', body: 'Our 17 year old chihuahua mix sleeps a lot and wakes disoriented. She\'s finding the Puppypad and NOT missing it! 1 week, hit it every time.' },
            { name: 'Jenny', where: 'US', date: 'Mar 24, 2026', tag: 'product', title: 'Miracle!', body: 'My 14 year old Chi mix has had accidents in our house her entire life. We have had our puppy pads for about a month and she hasn\'t gone anywhere else since. I am amazed and wish I had found these 14 years ago!' },
            { name: 'Nancy Callahan', where: 'US', date: 'Apr 26, 2026', tag: 'senior', title: 'Best pads ever', body: 'I have a pup that is not trainable she has water on the brain and she is blind. Was hesitant to try these pads but finally gave them a try and so glad I did. Took her a day or 2 but now goes on them every time. I now own 8 of them. I highly recommend .' },
            { name: 'Ruth', where: 'US', date: 'Feb 12, 2026', tag: 'senior', title: 'We were desperate!', body: 'We had a major problem with our elderly toy poodles: they meant well, but they always seemed to just miss the old peepads. In this case, a miss is as good as a mile, but the dogs are old, arthritic, and one is blind. Then I saw the add for PuppyPads, and thought, why not give it a try? and sure enough, even the blind dog has no problem hitting the spot. Whew!' },
            { name: 'Paula White', where: 'US', date: 'Dec 22, 2025', tag: 'product', title: 'I love these pads', body: 'I love these pads. My dog Maryann is 13 years old and pees at night. When I put down the first pad, I was nervous she wouldn\'t use it. So I put a disposable one next to it just in case. Well in the morning the disposable one was not used. She went straight to the puppy pad. Pick up was easier cause there was no dripping or smell. She has used only the puppy pad ever since.' },
            { name: 'Carolyn Torres', where: 'US', date: 'Dec 20, 2025', tag: 'product', title: 'I was having so much trouble training...', body: 'I was having so much trouble training my shih ztu puppy I\'ve had her since she was 8wks old I was about ready to give up on her when I came across the puppy pads, I thought I might as well try these I\'ve tried every thing else I\'ve read about I\'ll give these a try if this doesn\'t work I hate to think of it but I\'ll have to call the people I bought her from n see if they will come n get her even if it went me losing the 1500.00 $ I pd for her. But to my surprise they really worked. I am so HAPPY I can keep my baby n my house doesn\'t smell like pee anymore. I even bought 2 more sets 1 so I will have enough between washing them and a set for my daughter which I bought my baby\'s sister for her. She\'s also bought an second set also. Thank you for helping us potty training our babies. Carolyn Torres Dahlonega, Georgia' },
            { name: 'Carlota Allocco', where: 'US', date: 'Jul 3, 2026', tag: 'product', title: 'Game Changer!', body: 'Puppy Pads has been a game changer for my home and dog. I have a Yorkie and it was very difficult trying to train him to pee on those paper pads. It took a long time and was still not entirely efficient. In addition I spent a lot of monthly income on those paper pads! From day one of using puppy pads it has been wonderful. My Yorkie uses them and even with rugs in the house, he only uses the Puppy pads. Love them!!💕 I won’t ever go back to messy paper pads!' },
            { name: 'Debbie', where: 'US', date: 'Jun 28, 2026', tag: 'senior', title: 'They have been a life savor for me', body: 'They have been a life savor for me. While getting chemo & radiation, I had days I didn\'t have the the energy to take my girls out but I had the potty pads! I used to buy the disposable ones but that gets expensive!' },
            { name: 'm woodall', where: 'US', date: 'Jul 11, 2026', tag: 'senior', title: 'These Work!', body: 'Every item I ordered came as expected and packaged very well. Even the box with the puppy detergents arrived without dents or torn. Very good. The pads are so great. I am in a wheelchair and often not able to take Ruby out especially when it rains. So, these pads never fail. She hits the mark everytime. These pads are great Thank You!' },
            { name: 'Julie Blank', where: 'US', date: 'Sep 8, 2023', tag: 'wash', title: 'You will not be disappointed in this product!', body: 'Having a paralyzed shepherd who will not wear a diaper (have you tried to herd cats?!), washing her comforters turns into a daily function, sometimes twice a day. Finding this company and ordering 3 of the large pads has turned into a God Send! I put the pee pads on top of her comforters and they absorb the urine. Washing these pads is so much easier than constantly washing her comforters, plus they dry so quickly. You will not be disappointed by this product, highly recommend them!!' },
            { name: 'HThomae', where: 'US', date: 'Jan 11, 2024', tag: 'senior', title: 'The broken leg adventure', body: 'My rescue came from a puppy mill where she was a breeder for almost 6 years. She has never lived in a house before. I started potty training, but it is Vermont in the winter. We were making good progress until I broke my leg. Matilda won\'t walk with anyone else, but she will use the puppy pads, thank goodness. Never with anyone watching, so no pics, but I could send a picture of Matilda.' },
            { name: 'Holly', where: 'US', date: 'Apr 15, 2026', tag: 'product', title: 'For all the people mentioning the poop...', body: 'For all the people mentioning the poop issue, here\'s our experience with these pads. We put this pad on our porcelain tile floor with a disposable pad on top of it. We have both a male and female Shih Tzus. They are both rescues and have been with us for four and five years now. They both go outside to potty and use the pad when they need to when we\'re not home. They still go to the door when we\'re home because they prefer to go outside. They know the pad is available when they need it. We use the disable pad on top to make clean up easier especially if they poop. Since we\'ve started using these, neither of our dogs have left us surprises anywhere else in our home but on the pad. On occasion they use the edge of the disable pad and the washable pad catches any overflow. We\'ve also had some furry visitors that went right to our pad corner insticntively. I realize many may think using both this pad and the disabled are overkill, but it keeps our home clean with very little maintenance. Our situation also show that the pheromones work well even with a disposable pad on top of this pad. We rotate our four pads at home and we always use them for travel. Three stay in our dogs travel bag. Our dogs don\'t have any issues with chewing or moving the disable pad we place on top either. They wash very well in cold water and dry very quickly. Finally, with the exception of a few emergencies, our dogs mainly use the pads for pee pee. They just prefer to poop outside always. They want to do all their business outside, but the pad is a lifesaver for overnight and longer days. It has in no way ruined their overall training. But as all dogs are different, one of our two tends to use the pad more. The pad was actually super-helpful in showing us our female was peeing excessively several months ago. This made us get her right to our vet and find out she has Cushion\'s disease. We caught it early and got her on the meds she needs. I hope you find this helpful.' },
            { name: 'Debra Adams', where: 'US', date: 'Jan 28, 2026', tag: 'product', title: 'Our puppy arrived before your order...', body: 'Our puppy arrived before your order did. In the interim, we used the standard paper pads and had a heck of a time trying to train him to use them. My swimmer wet jet felt like it was permanently attached to my arm. The dy the order arrived, I put them down and he knew right where to go! I tried one for the first time outside, to train him to go in a particular spot. He had access to all of the great outdoors and used the pad. I don\'t know what kind of fairy dust you put in them, but to me it\'s miraculous! I\'ve retired my mop and things ar great. Thank you for providing such a great product. I had also added the soap to my order and again, not a stain remains after washing. I have recommended them to several people, including the breeder when we picked up my puppy. Bravo for such a great and useful product that works like magic!' },
            { name: 'Sandra', where: 'US', date: 'Jun 6, 2026', tag: 'product', title: 'Puppy Pads are Great!!!', body: 'When I received the package, I put the pads down to replace paper training pads. To my surprise all 3 of our dogs went towards them to check them out! Yeah!!! They went and they have used the pads right away!! So, I ordered another package of 6 along with the laundry detergent to wash the pads! I would like to tell your readers that they DO WORK!!!!! Sandra' },
            { name: 'Laura Schuder', where: 'US', date: 'May 24, 2026', tag: 'product', title: 'Puppypad’s gave me peace of mind!', body: 'I have to say I had little faith that something like this would work. I could not believe how quickly my dachshund took to it! Now we never come home to messes! Just throw it in the machine with the special detergent sheets and you’re done! Fabulous product, even my husband was amazed!!' },
            { name: 'Charlotte', where: 'US', date: 'Apr 23, 2026', tag: 'product', title: "I'm flabbergasted!", body: "I\'m flabbergasted at how well these pads work for us! I have 3 little older dogs (ages 11 to 17) and \"oopsies\" were frequent in our house. We went through dozens of paper piddle pads each month which was expensive and ugly. When I put the new pads down, they sniffed for a day, no accidents -- then they always use the pads but try to signal to go outside first. Less mess! Awesome job, guys!" },
            { name: 'Lynn', where: 'US', date: 'Nov 29, 2025', tag: 'senior', title: 'Old dog learns new trick!', body: 'I have a 13 year old rescue who had never been potty trained. He used the whole kitchen and peed close to the paper pads but not on them. I put down the reusable pads and he immediately got it. No more peeing on the floor. Not once. It is amazing. I was trying for a year and all of a sudden he got it!' },
            { name: 'Dawn Mcclain', where: 'US', date: 'May 13, 2026', tag: 'senior', title: 'Great for potty shy Puppies!', body: 'I rescued my puppy Henry from a hoarding situation. He will not potty outside. I don\'t know if it\'s because he was kept in a diaper before I got him. He has used the puppy pads without fail since day one! They are a blessing!' },
            { name: 'Diana Colborne', where: 'US', date: 'Dec 23, 2025', tag: 'value', title: 'These puppy pads are everything...', body: 'These puppy pads are everything they say they are!! I have no more accidents on the floor! The disposal pads never worked ! My dogs would miss or only partly hit the pad! They have gone on these pads every single time! My dogs are both rescues who never learned to be in a house until they were 8 and ten! I\'m so thankful and grateful for this product! Being washable has saved me a ton of money!' },
            { name: 'Aaron Zaccagino', where: 'US', date: 'Jan 31, 2026', tag: 'value', title: 'Night and day difference', body: 'We have an adolescent Old English Sheepdog that never really out grew the use of "paper puppy pads" we had gone through hundreds of $$ worth of disposable pads, replaced throw rugs etc. once we purchased your products, its been like night and day!!! We swap out pads about three times a day, and still have three as a back up... its amazing and we have probably saved in what we paid for your products already in two weeks! THANK YOU' },
            { name: 'Brenda', where: 'US', date: 'Apr 9, 2026', tag: 'value', title: 'Like magic in a bottle', body: 'Like magic in a bottle. As soon as I placed them, my fur babies knew tight where to go. Thanks so much I\'m saving over 100.00 per month now' },
            { name: 'Anne', where: 'US', date: 'Apr 5, 2026', tag: 'senior', title: 'My 80-year-old heart is full', body: 'We have a sweet wonderful 13 year old rescued that we have had for 10 years. This old fella means the world and more to me. I am an 80 year old widow with COPD which makes life difficult at times. We had our house raised due to flooding. Our boy Jake was already having problems with the stairs, and was having accidents, by not making it outside and down the steps fast enough and would fall sometimes. He is a big guy and hard for me to help him up. The poor old boy was embarassed when he had an accident, you could see it in his face. I saw the ads for the puppy pads and decided to order some. They arrived promptly, and I took one into the next room and put it down. Before long he was getting himself up to go out. He walked into the room with the pad, walked over to it, sniffed it and peed!! Just as advertised! I could not believe how well it worked, and how easily he found it to be. I was worried that he might need to be put down and it broke my heart. Thanks to the pads I will be able to enjoy his company much longer. PS. They wash beautifully, and I do air dry them. They dry quickly.' },
            { name: 'Jana', where: 'US', date: 'Jul 16, 2026', tag: 'wash', title: 'Best Puppy Pad ever!', body: 'Wonderful company to work with! We bought 9 puppy pads and they have been a game changer in our house. I’m still shocked that they work so well. When we used paper puppy pads, it was a mess to clean up and I was constantly cleaning up. These puppy pads DO NOT leak. I’ve washed them so many times and they still look good as new. I never want to be without them! Thank you to an awesome company!' },
            { name: 'Michael Bennington', where: 'US', date: 'Jun 9, 2026', tag: 'value', title: 'OMG puppy pads are the best investment', body: 'OMG puppy pads are the best investment I\'ve ever made. As a breeder I always had to change pads for Mom until the pipes were both then until at least 4 weeks by the time puppies needed to be trained for a few weeks before going home I had give thru a minimum of 5 boxes of 150 pads at 20 dollars source that 100 dollars then had to be burned out taken to the garbage ... BURNED I wasn\'t driving hundreds of pounds of dog poop with me to the dump. Either way I bought 2 sets of the but 3 get 3 free for 150 so 300 dollars total and have 2 females in different rooms that had never seen these pads whereas I had to cover the entire floor with pads and waste of money they only go where the pad is and 3 weeks in no accidents. I also get minimum of 3 days per pad as long as I pick up the poop! Can\'t wait to see if when I wean the puppies they will go use them as well! Great product!' },
            { name: 'Susan', where: 'US', date: 'Apr 18, 2026', tag: 'value', title: 'Breeders with 50+ puppies', body: 'We are breeders and have 5 dogs and 50+ puppies have came through our home. We have went through thousands of pads at great cost. Then we discovered Puppy Pads! Great customer service and the product is phenomenal! No matter how many times they are washed the puppies still go right to them without training! Thank you Puppy Pad for saving our home, and wallet.' },
            { name: 'Kathryn Richards', where: 'US', date: 'Aug 10, 2026', tag: 'service', title: 'The Customer Service is super…', body: 'The Customer Service is super responsive, very friendly and effective! The puppy pads and laundry sheets are of excellent quality and very long lasting! Highly recommend!' },
            { name: 'Janet Kaplan', where: 'US', date: 'Aug 3, 2026', tag: 'service', title: 'Kudos to Emma', body: 'I emailed Puppy Pad to ask several questions. Emma emailed me back within a few minutes, answering my questions directly, precisely & offered to change the shipping address since it hasn’t as yet shipped. She genuinely cared & was so helpful. It was reassuring to me that I was in good hands. Emma is an excellent employee & should be recognized for doing such an exemplary job. Kudos to her & to whoever hired her‼️' },
            { name: 'Beverly Jennings', where: 'US', date: 'Jul 28, 2026', tag: 'product', title: 'Puppy Pads for Sparky J', body: 'Puppy Pads are great! Their customer service is always very helpful and I never have any problems when ordering. I was having a hard time getting Sparky J to use the throw away pee pads from Walmart as he would tear it up instead of peeing on it...very frustrating. Just wanted to let you know how all went...these pads work so well he actually comes in from outside and runs straight to Puppy Pad to do his business!!! I thought your staff would get a kick out of this!' },
            { name: 'Sir Thomas', where: 'US', date: 'Aug 12, 2026', tag: 'wash', title: 'They are exactly as advertised', body: 'They are exactly as advertised. My dog went right to them. The waterproof backing is marvelous and a wash in the washing machine very well. The top layer is interesting because it doesn’t show a P Mark. I’m just glad that I don’t have to use those old paper pee pads anymore.' },
            { name: 'Catherine Sprague', where: 'US', date: 'Jul 31, 2026', tag: 'wash', title: 'These pads work as advertised. Best product a dog owner can buy', body: 'I have 4 doxies and they are hard to train at times. When I put the pads down they started using them on day one. I am so happy plus the pads are washable. I was worried that the pups would not use them after the wash but no problem. Plus there is no odor when used. I love this product' },
            { name: 'Connie Meshell', where: 'US', date: 'Aug 4, 2026', tag: 'wash', title: 'I have 2 dogs', body: 'I have 2 dogs. One is a border collie & the other is a dachshund. The paper pads they would not use & the dachshund would tear them up all over the house. I bought 6 puppy pads & I’d highly recommend them. They really help out if it rains cause my dogs will not go potty in the rain. They wash & dry fairly fast too.' },
            { name: 'Kathe Dobson', where: 'US', date: 'Jul 30, 2026', tag: 'wash', title: 'Wow! Really works', body: 'Wow! This pad works. Time and time again. My puppy goes a lot and always hits the pad. It is so easy to wash and use again. I bought 3 large so I am set up. This took the stress of puppy training right off me. Super company that care about their customers. Get yours today so you can relax!' },
            { name: 'Rhonda Hicks', where: 'US', date: 'Apr 29, 2026', tag: 'wash', title: 'We love puppy pads they are so…', body: 'We love puppy pads they are so convenient! Our Yorkshire Terrier took right to them. They wash and dry up so nice and save so much money! Wish we would have done it sooner! Rhonda' },
            { name: 'Joyce', where: 'US', date: 'Jul 23, 2026', tag: 'wash', title: 'We were so impressed with the first 6…', body: 'We were so impressed with the first 6 Puppy Pads we purchased that we just purchased 6 more! We have multiple rescue dogs, along with family furbabies and we have tried so many things to help eliminate "accidents" and odor in our home. We now can walk through our home without fear of stepping in potty puddles!!' },
            { name: 'Kay Hamill', where: 'US', date: 'Aug 11, 2026', tag: 'value', title: 'Puppy Pads are the Best!', body: 'Puppy Pads are the absolute best! I have dogs that destroy everything you put down for them, but not these! I use some of mine for them to lay on because they tear up anything else and they love them. They DON\'T STINK after use and can be washed after a couple of days and multiple uses if the dogs can\'t go out for some reason. Yes they cost more than disposable, but they last. I\'ve had my first set for over three years!' },
            { name: 'Claudette', where: 'US', date: 'Apr 29, 2026', tag: 'value', title: 'These are great', body: 'These are great. They worked right away and my 2 elderly dogs took to them immediately. I cancelled the pee pad sub that I had with Chewy, it was so expensive and stressing. No more stress over pee inside when we can\'t get them out. I have 3, going to get 3 more next month.' },
            { name: 'Jennifer Walker', where: 'US', date: 'Jul 28, 2026', tag: 'value', title: 'Worth the price', body: 'This is the second time buying Puppy Pads. I bought my first pads some time ago and they worked great. Then I saw a different brand of pads that were cheaper. Bought them and then found out they did not wash up like the Puppy Pads. The saying is true. You get what you pay for. Cheaper pads were not worth it. Bought my second set of Puppy Pads and have no regrets about it.' },
            { name: 'Deb', where: 'US', date: 'Aug 1, 2026', tag: 'service', title: 'Puppy pads are the only ones that worked for my dogs', body: 'Puppy pads have worked so well for my dogs and new puppy. They train so much faster and that helps so much. They don’t even leave a smell. Customer service help quickly responds to issues or questions that I found. They are extremely responsive kind and want to make sure you are happy! You should try these pads.' },
            { name: 'Suzi Norling', where: 'US', date: 'Jul 31, 2026', tag: 'service', title: 'Emma responded to my email immediately…', body: 'Emma responded to my email immediately and had the perfect solution for me. She was friendly and kind, and it was a breath of fresh air to communicate with someone who actually answered my question. If only all customer service was this great, thank you, Emma!' },
            { name: 'MELINDA MADDOX', where: 'US', date: 'Jul 30, 2026', tag: 'service', title: 'Puppy Pads are really amazing', body: 'Puppy Pads are really amazing! My crew love to chew up disposable pee pads (and strew the soda/charcoal everywhere)…but these pads don’t generate that behavior. Also, there was no having to train the pups to use the pads! They started as soon as I put them on the floor! I think we’ve purchased 30, so far…and we will be back for more. Great product. Great customer service!' },
            { name: 'Marisa', where: 'US', date: 'Jul 26, 2026', tag: 'service', title: 'The puppy pads actually work!', body: 'The puppy pads actually work, and so do the laundry sheets. So I would say, go ahead and get yourself these puppy pads, it\'s going to save you a ton of cleaning. Use the laundry sheets so that the pads don\'t lose their pheromones. Also customer service has been really easy to work with and I\'m very pleased with the company all together!' },
            { name: 'Honey', where: 'US', date: 'Aug 2, 2026', tag: 'service', title: 'PuppyPads responds to request quickly', body: 'I love my PuppyPads. Honey is wonderful about using them when we can\'t go outside. I subscribed to the washing machine soap. I love how clean the pads get. Somehow, I got too many unused boxes, I contacted PuppyPad e-mail and asked that they hold the shipment for a few months. Their response was within 10 minutes that my request was received and the shipment held. I love fast service!' }
              ];
              }
              var AVA = ['#E8710A', '#7B5CD6', '#0A7D6E', '#C23B78', '#3B6FC2', '#B3821F', '#5E8C31', '#A04ED6', '#C25B3B', '#2F8CA3'];
              var FILTER_LABELS = { ALL: 'All reviews', product: 'Used it right away', senior: 'Senior & rescue dogs', wash: 'Washing & smell', value: 'Saves money', service: 'Customer Support' };
              var wallFilter = 'ALL';

              function makeCard(r, avaBg) {
                var card = document.createElement('div');
                card.className = 'tp-card';
                var head = document.createElement('div');
                head.className = 'tp-head';
                var ava = document.createElement('span');
                ava.className = 'tp-ava';
                ava.style.background = avaBg;
                ava.textContent = r.name.charAt(0).toUpperCase();
                var who = document.createElement('div');
                who.className = 'tp-who';
                var nm = document.createElement('span');
                nm.className = 'tp-name';
                nm.textContent = r.name;
                var wh = document.createElement('span');
                wh.className = 'tp-where';
                wh.textContent = r.where + ' · 1 review';
                who.appendChild(nm); who.appendChild(wh);
                head.appendChild(ava); head.appendChild(who);
                var meta = document.createElement('div');
                meta.className = 'tp-meta';
                meta.innerHTML = '<img src="' + CDN + 'trustpilot.svg?v=1785853341" alt="Trustpilot 5 stars" class="tp-stars fk-disable-lazy"><span class="tp-verified"><span>✓</span>Verified</span>';
                var dt = document.createElement('span');
                dt.className = 'tp-date';
                dt.textContent = r.date;
                meta.appendChild(dt);
                var ti = document.createElement('div');
                ti.className = 'tp-title';
                ti.textContent = r.title;
                var bd = document.createElement('p');
                bd.className = 'tp-body';
                bd.textContent = r.body;
                var more = document.createElement('span');
                more.className = 'tp-more';
                more.textContent = 'Read more';
                card.appendChild(head); card.appendChild(meta); card.appendChild(ti); card.appendChild(bd); card.appendChild(more);
                card.addEventListener('click', function () {
                  openReviewModal(r, avaBg);
                });
                return card;
              }

              function buildWall() {
                var wall = document.getElementById('tpWall');
                if (!wall) return;
                var list = getReviews().filter(function (r) { return wallFilter === 'ALL' || r.tag === wallFilter; });
                var per = Math.ceil(list.length / 3);
                var durs = [4.4, 5.4, 4.8];
                wall.innerHTML = '';
                for (var ci = 0; ci < 3; ci++) {
                  var col = document.createElement('div');
                  col.className = 'tp-col';
                  var slice = list.slice(ci * per, ci * per + per);
                  for (var pass = 0; pass < 2; pass++) {
                    for (var k = 0; k < slice.length; k++) {
                      col.appendChild(makeCard(slice[k], AVA[(ci * per + k) % AVA.length]));
                    }
                  }
                  col.style.setProperty('--wallDur', Math.max(18, Math.round(slice.length * durs[ci])) + 's');
                  col.style.setProperty('--wallDelay', (-ci * 7) + 's');
                  wall.appendChild(col);
                }
              }

              function setFilter(f) {
                wallFilter = f;
                qsa('#hlpFilterLinks .rv-flink').forEach(function (b) {
                  b.classList.toggle('is-on', b.getAttribute('data-filter') === f);
                });
                var s = document.getElementById('hlpFilterSelect');
                if (s && s.value !== f) s.value = f;
                setText('hlpFilterLabel', FILTER_LABELS[f]);
                buildWall();
              }

              // ---- gifts (content copied from the PDP gift modal) ----
              var giftData = [{
                    headline: "Potty training with PuppyPad",
                    image: "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Potty-Training-With-PuppyPad-Preview-IMG.png?v=1788972215",
                    body: "This guide shows you the exact 2-phase method that helped one puppy have just ONE accident at 7 weeks old. You'll learn the timing secrets, how to spot those \"gotta go\" signals, and the positive reinforcement tricks that actually make dogs choose their PuppyPad every time - no harsh training needed."
                 },
                 {
                    headline: "Dog Care 101",
                    image: "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Dog-Car-101-Preview-IMG.png?v=1788972196",
                    body: "This guide covers all the stuff nobody really tells you about - like how often you should actually bathe your dog (hint: way less than you think), which foods can literally kill them, and why shaving double-coated dogs is a terrible idea. Plus the grooming tricks, health checks, and exercise tips that'll keep your dog healthy and happy for years."
                 },
                 {
                    headline: "How To Choose The Best Dog Food",
                    image: "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/How-To-Choose-Food-Preview-IMG.png?v=1788972209",
                    body: "This guide breaks down all the dog food options out there - from kibble to raw to frozen - and explains what actually matters when you're staring at those confusing labels. You'll learn which types work best for puppies versus seniors, dogs with allergies, or picky eaters, plus the insider info on what \"premium\" really means (spoiler: sometimes it's just marketing)."
                 }
              ];
              var giftIndex = 0;

              function ensureGiftSlides() {
                var track = document.getElementById('giftCarouselTrack');
                if (!track || track.children.length) return;
                giftData.forEach(function (g) {
                  var slide = document.createElement('div');
                  slide.className = 'gift-slide';
                  var im = document.createElement('img');
                  im.src = g.image;
                  im.alt = g.headline;
                  im.width = 600;
                  im.height = g.image.indexOf('How-To-Choose-Food') > -1 ? 300 : 309;
                  // Created only on modal open, after intent/approach warming.
                  // Native lazy loading can delay the next slide even when its
                  // bytes are cached, so all three are ready for rapid swipes.
                  im.loading = 'eager';
                  im.decoding = 'async';
                  slide.appendChild(im);
                  track.appendChild(slide);
                });
              }

              function renderGift() {
                var g = giftData[giftIndex];
                setText('giftModalHeadline', g.headline);
                setText('giftModalBody', g.body);
                setText('giftCounter', (giftIndex + 1) + ' / ' + giftData.length);
                var track = document.getElementById('giftCarouselTrack');
                if (track) {
                  track.style.transition = 'transform .3s ease';
                  track.style.transform = 'translateX(-' + (giftIndex * 100) + '%)';
                }
              }

              function moveGift(delta) {
                giftIndex = (giftIndex + delta + giftData.length) % giftData.length;
                renderGift();
              }

              // Reserve the tallest heading/body at the current modal width.
              // Otherwise text wrapping moves the arrows between consecutive taps.
              function sizeGiftCopy() {
                var panel = document.getElementById('hlpGiftPanel');
                if (!panel || panel.style.display === 'none') return;
                var targets = [document.getElementById('giftModalHeadline'), document.getElementById('giftModalBody')];
                var fragment = document.createDocumentFragment(), probes = [];
                targets.forEach(function (target, group) {
                  var width = target.getBoundingClientRect().width;
                  giftData.forEach(function (gift) {
                    var probe = target.cloneNode(false);
                    probe.removeAttribute('id');
                    probe.setAttribute('aria-hidden', 'true');
                    probe.textContent = group === 0 ? gift.headline : gift.body;
                    probe.style.cssText += ';position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;min-height:0;width:' + width + 'px';
                    fragment.appendChild(probe);
                    probes.push({ element: probe, group: group });
                  });
                });
                panel.appendChild(fragment);
                var heights = [0, 0];
                probes.forEach(function (probe) { heights[probe.group] = Math.max(heights[probe.group], probe.element.getBoundingClientRect().height); });
                probes.forEach(function (probe) { probe.element.remove(); });
                targets.forEach(function (target, group) { target.style.minHeight = Math.ceil(heights[group]) + 'px'; });
              }

              function setupGiftSwipe() {
                var track = document.getElementById('giftCarouselTrack');
                if (!track || track._hlpSwipe) return;
                track._hlpSwipe = true;
                var startX = 0, startY = 0, curX = 0, dragging = false;
                track.addEventListener('touchstart', function (e) {
                  if (e.touches.length > 1) { dragging = false; return; } // pinch stays with the browser
                  dragging = true;
                  startX = curX = e.touches[0].clientX;
                  startY = e.touches[0].clientY;
                  track.style.transition = 'none';
                }, { passive: true });
                track.addEventListener('touchmove', function (e) {
                  if (!dragging) return;
                  if (e.touches.length > 1) { dragging = false; renderGift(); return; }
                  curX = e.touches[0].clientX;
                  var diffX = curX - startX;
                  var diffY = e.touches[0].clientY - startY;
                  if (Math.abs(diffX) > Math.abs(diffY)) {
                    e.preventDefault();
                    var w = track.parentElement.offsetWidth || 1;
                    track.style.transform = 'translateX(' + (-(giftIndex * 100) + (diffX / w) * 100) + '%)';
                  }
                }, { passive: false });
                track.addEventListener('touchend', function () {
                  if (!dragging) return;
                  dragging = false;
                  var w = track.parentElement.offsetWidth || 1;
                  var moved = startX - curX;
                  if (Math.abs(moved) > w * 0.15) moveGift(moved > 0 ? 1 : -1);
                  else renderGift();
                });
              }

              // ---- modal manager ----
              var MODAL_SIZES = {
                size: 'min(600px,90vw)',
                gifts: 'min(560px,93vw)',
                review: 'min(600px,93vw)'
              };
              var PANELS = { size: 'hlpSizePanel', gifts: 'hlpGiftPanel', review: 'hlpReviewPanel' };
              var activeModal = null;

              function openModal(name) {
                var overlay = document.getElementById('hlpModal');
                var box = document.getElementById('hlpModalBox');
                if (!overlay || !box) return;
                activeModal = name;
                Object.keys(PANELS).forEach(function (k) {
                  var p = document.getElementById(PANELS[k]);
                  if (p) p.style.display = k === name ? 'block' : 'none';
                });
                box.style.maxWidth = MODAL_SIZES[name];
                box.style.background = name === 'review' ? 'transparent' : '#FFF9F4';
                box.style.padding = name === 'review' ? '0' : 'clamp(18px,2.4vw,28px)';
                var closeBtn = document.getElementById('hlpModalClose');
                if (closeBtn) closeBtn.style.display = 'block';
                overlay.style.display = 'flex';
                if (name === 'gifts') sizeGiftCopy();
                qsa('img[data-hlp-src]', document.getElementById(PANELS[name]) || overlay).forEach(function (img) {
                  img.src = img.getAttribute('data-hlp-src');
                  img.removeAttribute('data-hlp-src');
                });
                box.scrollTop = 0; // always open from the top (scroll persists across close; must run after display)
                requestAnimationFrame(function () { overlay.style.opacity = 1; });
                document.body.style.overflow = 'hidden';
              }

              function closeModal() {
                var overlay = document.getElementById('hlpModal');
                if (!overlay) return;
                activeModal = null;
                overlay.style.display = 'none';
                overlay.style.opacity = 0;
                document.body.style.overflow = '';
              }

              // trust line: when the two halves would wrap at the current width
              // (long geo city names, the narrower two-column desktop card), switch
              // the row to the same clean stacked layout as phones — centered
              // lines, no dangling "|". Measured from the unstacked baseline so it
              // recovers when the width grows again.
              function trustSep() {
                var row = qs('.post-purchase-info');
                if (!row) return;
                row.classList.remove('is-stacked');
                var halves = qsa('.pp-trust-half', row);
                if (halves.length < 2) return;
                var wrapped = Math.abs(halves[0].getBoundingClientRect().top - halves[1].getBoundingClientRect().top) > 4;
                if (wrapped) row.classList.add('is-stacked');
              }

              function openReviewModal(r, avaBg) {
                var ava = document.getElementById('rvAva');
                if (ava) { ava.style.background = avaBg || '#001B74'; ava.textContent = r.name.charAt(0).toUpperCase(); }
                setText('rvName', r.name);
                setText('rvWhere', r.where);
                setText('rvDate', r.date);
                setText('rvDate2', r.date);
                setText('rvTitle', r.title);
                setText('rvBody', r.body);
                openModal('review');
              }

              // ---- selection hint (mobile only) ----
              // After a size/colour change the gallery has already jumped to the fit
              // photo, but on stacked layouts that photo sits off-screen above — so a
              // small note under the changed row points back up. One hint at a time;
              // it fades out on its own after ~4s.
              var HINT_MQ = window.matchMedia ? window.matchMedia('(max-width: 899px)') : null;
              var hintT;
              function showSelHint(kind) {
                if (!HINT_MQ || !HINT_MQ.matches) return;
                var show = document.getElementById(kind === 'size' ? 'hlpSizeHint' : 'hlpColorHint');
                var hide = document.getElementById(kind === 'size' ? 'hlpColorHint' : 'hlpSizeHint');
                if (!show) return;
                var pill = show.querySelector('.hlp-selhint-pill');
                if (pill) pill.textContent = kind === 'size'
                  ? 'Tap to see the ' + sel.size + ' size ↑'
                  : 'Tap to see it in ' + sel.color + ' ↑';
                if (hide) hide.classList.remove('is-show');
                show.classList.add('is-show');
                clearTimeout(hintT);
                hintT = setTimeout(function () { show.classList.remove('is-show'); }, 4000);
              }

              // ---- sticky bar + lazy videos ----
              var stickyBar = document.getElementById('ctaBar');
              var stickyGate = document.getElementById('fiveLayers');
              var ctaSections = qsa('[data-cta]');
              var loopVideos = qsa('video[data-lazyvid]');
              function poll() {
                var vh = window.innerHeight || 800;
                var bar = stickyBar;
                var want = '0';
                if (bar) {
                  var gate = stickyGate;
                  var pastGate = gate ? gate.getBoundingClientRect().bottom < vh : false;
                  var clash = ctaSections.some(function (el) {
                    var r = el.getBoundingClientRect();
                    return r.bottom > 0 && r.top < vh && r.height > 0;
                  });
                  want = (!pastGate || clash) ? '0' : '1';
                }
                // Sources/posters attach near the viewport; playback is limited
                // to visible clips. Hidden gallery videos have zero dimensions.
                // Complete all geometry reads before changing styles or playback.
                var videoStates = document.readyState === 'complete' ? loopVideos.map(function (v) {
                  var r = v.getBoundingClientRect();
                  return { video: v, visible: !document.hidden && r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < vh };
                }) : [];
                if (bar && (bar.style.opacity !== want || !bar.style.pointerEvents)) {
                  bar.style.opacity = want;
                  bar.style.transform = 'translateX(-50%)' + (want === '1' ? '' : ' translateY(150%)');
                  bar.style.pointerEvents = want === '1' ? 'auto' : 'none';
                  bar.setAttribute('aria-hidden', want === '1' ? 'false' : 'true');
                }
                videoStates.forEach(function (state) {
                  var v = state.video;
                  if (state.visible) {
                    window.hlpLoadVideo(v);
                    if (v.ended || (v.duration && v.currentTime >= v.duration - 0.05)) v.currentTime = 0;
                    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
                  } else if (!v.paused) v.pause();
                });
              }

              // ---- CKC lazy-restore watchdog ----
              // Their loader occasionally strands an image on its data-URI
              // placeholder or a failed fetch (races in its restore, seen as
              // broken arrow/warning icons in the wild). Put the real src back
              // from data-src and retry one failed load per image.
              function healImages() {
                qsa('img').forEach(function (im) {
                  var ds = im.getAttribute('data-src');
                  var src = im.getAttribute('src') || '';
                  if (ds && (!src || src.indexOf('data:') === 0)) { im.setAttribute('src', ds); return; }
                  if (src && src.indexOf('data:') !== 0 && im.complete && im.naturalWidth === 0 && !im.__retried) {
                    im.__retried = 1;
                    im.removeAttribute('src');
                    im.setAttribute('src', src);
                  }
                });
              }

              // ---- Loox (lazy, same shop widget as the PDP; frame styling is
              // handled by the PDP's hideLooxStars block in the next script) ----
              var looxLoaded = false;
              function loadLoox() {
                var wall = document.getElementById('looxWall');
                var near = wall && wall.getBoundingClientRect().top < (window.innerHeight || 800) + 2500;
                if (near && !looxLoaded) {
                  looxLoaded = true;
                  var sc = document.createElement('script');
                  sc.src = 'https://loox.io/widget/loox.js?shop=puppypad1.myshopify.com';
                  sc.async = true;
                  document.head.appendChild(sc);
                  window.removeEventListener('scroll', loadLoox);
                }
              }

              // ---- init ----
              document.addEventListener('DOMContentLoaded', function () {
                // CKC's importer converts pasted <button>/<a> elements into its
                // fkt components and stamps onclick="callMethod(event)" (plus
                // title/href stubs) on them, so taps on non-routing controls
                // popped "No page routing found" and links grew hover tooltips.
                // Only the real ATC may route — scrub everything else.
                qsa('button, a, [onclick]').forEach(function (el) {
                  if (el.classList && el.classList.contains('fk-addToCartBtn')) return;
                  el.removeAttribute('onclick');
                  el.onclick = null;
                  if (el.getAttribute('title')) el.removeAttribute('title');
                  if (el.tagName === 'A') {
                    var h = el.getAttribute('href');
                    if (h === '' || h === '#') el.removeAttribute('href');
                  }
                });

                qsa('video').forEach(function (m) { m.muted = true; m.defaultMuted = true; m.playsInline = true; });

                // Keep our deferred URLs separate from CKC's data-src machinery.
                // The hero starts after its still is decoded, so its 5.7 MB video
                // cannot compete with the first visible image/headline download.
                var hero = qs('.heroMedia video');
                function startHero() {
                  if (!hero) return;
                  window.hlpLoadVideo(hero);
                  if (!document.hidden) {
                    var p = hero.play(); if (p && p.catch) p.catch(function () {});
                  }
                }
                if (hero) {
                  var still = new Image();
                  still.src = hero.poster;
                  if (still.decode) still.decode().then(startHero, startHero);
                  else if (still.complete) startHero();
                  else still.onload = still.onerror = startHero;
                }
                function armMedia() {
                  var pending = qsa('video[data-hlp-src], video[data-hlp-poster]').filter(function (v) { return v !== hero; });
                  function prepare(v) {
                    window.hlpLoadVideo(v);
                    // Poster-less loops need their first frame ready on approach.
                    if (!v.poster && v.hasAttribute('data-lazyvid')) v.preload = 'metadata';
                  }
                  if ('IntersectionObserver' in window) {
                    var mediaObserver = new IntersectionObserver(function (entries) {
                      entries.forEach(function (entry) {
                        if (entry.isIntersecting) { prepare(entry.target); mediaObserver.unobserve(entry.target); }
                      });
                    }, { rootMargin: '600px 0px' });
                    pending.forEach(function (v) { mediaObserver.observe(v); });
                  } else pending.forEach(prepare);
                  poll();
                  var looxWall = document.getElementById('looxWall');
                  if (looxWall && 'IntersectionObserver' in window) {
                    new IntersectionObserver(function (entries, obs) {
                      if (entries[0].isIntersecting) { loadLoox(); obs.disconnect(); }
                    }, { rootMargin: '2500px 0px' }).observe(looxWall);
                  } else {
                    window.addEventListener('scroll', loadLoox, { passive: true });
                    loadLoox();
                  }
                }
                if (document.readyState === 'complete') armMedia();
                else window.addEventListener('load', armMedia, { once: true });

                // selectors (delegated per group)
                function wireGroup(rowId, optSelector, attr, prop, after) {
                  var row = document.getElementById(rowId);
                  if (!row) return;
                  row.addEventListener('click', function (e) {
                    var opt = e.target.closest(optSelector);
                    if (!opt || !row.contains(opt)) return;
                    qsa(optSelector, row).forEach(function (x) { x.classList.remove('is-on'); });
                    opt.classList.add('is-on');
                    sel[prop] = opt.getAttribute(attr);
                    update();
                    persistSelections();
                    bump();
                    if (after) after();
                  });
                }
                wireGroup('hlpSizeRow', '.ob2-size', 'data-size', 'size', function () {
                  setSlide(0); // jump to the fit photo in the chosen size
                  showSelHint('size');
                });
                wireGroup('hlpColorRow', '.ob2-color', 'data-color', 'color', function () {
                  // on the fabric close-up the colour swaps in place; from any other
                  // slide jump to the fit photo in the chosen colour
                  if (GALLERY[gIdx].colorSrc) setSlide(gIdx);
                  else setSlide(0);
                  showSelHint('color');
                });
                wireGroup('hlpOfferRow', '.ob2-offer', 'data-offer', 'offer', function () {
                  var btn = document.getElementById('addToCartBtn');
                  if (!btn) return;
                  setTimeout(function () {
                    btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    btn.classList.remove('is-pulse');
                    void btn.offsetWidth;
                    btn.classList.add('is-pulse');
                  }, 150);
                });

                // offer info modal + review carousel
                setupModal('hlpOfferModal', 'offerInfoLink', 'hlpOfferModalClose', function () {
                  reviewSlides = reviewTrack ? Array.from(reviewTrack.children) : [];
                  sizeOfferSlides();
                });
                var hlpReviewPrev = document.getElementById('hlpReviewPrev');
                var hlpReviewNext = document.getElementById('hlpReviewNext');
                if (hlpReviewPrev) hlpReviewPrev.addEventListener('click', function () { moveOffer(-1); });
                if (hlpReviewNext) hlpReviewNext.addEventListener('click', function () { moveOffer(+1); });

                // ATC — refresh productInfo, then let CheckoutChamp take over
                var atc = document.getElementById('addToCartBtn');
                if (atc) {
                  atc.onclick = function (event) {
                    update(); // ensure productInfo reflects the latest selection
                    persistSelections();
                    if (this.dataset.outOfStock === 'true') {
                      event.preventDefault();
                      event.stopImmediatePropagation();
                      return false;
                    }
                    if (typeof route === 'function') return route(event);
                    if (typeof callMethod === 'function') return callMethod(event);
                    event.preventDefault();
                  };
                }

                // gallery
                var gPrev = document.getElementById('obPrev'), gNext = document.getElementById('obNext');
                if (gPrev) gPrev.addEventListener('click', function () { setSlide(gIdx - 1); });
                if (gNext) gNext.addEventListener('click', function () { setSlide(gIdx + 1); });
                // first render is deferred to bootGallery() (buy-box approach
                // observer) so the stage image and thumbs stay off the cold load

                // stage swipe: the slide follows the finger and the neighbour's
                // still drags in alongside; release past 15% commits the swipe
                var box = document.getElementById('obStageBox');
                var slA = document.getElementById('obSlideA');
                var slB = document.getElementById('obSlideB');
                if (box && slA && slB) (function () {
                  var sx = 0, sy = 0, dx = 0, drag = false, horiz = false, W = 1, dir = 0, tgt = 0, pid = null, anim = false;
                  box.addEventListener('pointerdown', function (e) {
                    if (anim) return;
                    if (e.pointerType === 'mouse' && e.button !== 0) return;
                    slB.removeAttribute('data-slide');
                    drag = true; horiz = false; dx = 0; pid = e.pointerId;
                    sx = e.clientX; sy = e.clientY;
                    W = box.clientWidth || 1;
                  });
                  box.addEventListener('pointermove', function (e) {
                    if (!drag || e.pointerId !== pid) return;
                    var mx = e.clientX - sx, my = e.clientY - sy;
                    if (!horiz) {
                      if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
                      if (Math.abs(mx) <= Math.abs(my)) { drag = false; return; } // vertical scroll wins
                      horiz = true;
                      try { box.setPointerCapture(pid); } catch (err) {}
                      slA.style.transition = 'none'; slB.style.transition = 'none';
                    }
                    dx = mx;
                    dir = dx < 0 ? 1 : -1;
                    tgt = (gIdx + dir + GALLERY.length) % GALLERY.length;
                    slB.style.display = 'block';
                    if (slB.getAttribute('data-slide') !== String(tgt) || !slB.style.backgroundImage) {
                      slB.style.backgroundImage = galleryBackground(GALLERY[tgt]);
                      slB.setAttribute('data-slide', tgt);
                    }
                    var p = (dx / W) * 100;
                    slA.style.transform = 'translateX(' + p + '%)';
                    slB.style.transform = 'translateX(' + (dir * 100 + p) + '%)';
                  });
                  function settle() {
                    if (!drag) return;
                    drag = false;
                    if (!horiz) return;
                    var commit = Math.abs(dx) > W * 0.15;
                    anim = true;
                    slA.style.transition = 'transform .25s ease';
                    slB.style.transition = 'transform .25s ease';
                    if (commit) {
                      slA.style.transform = 'translateX(' + (-dir * 100) + '%)';
                      slB.style.transform = 'translateX(0%)';
                    } else {
                      slA.style.transform = 'translateX(0%)';
                      slB.style.transform = 'translateX(' + (dir * 100) + '%)';
                    }
                    setTimeout(function () {
                      slA.style.transition = 'none'; slB.style.transition = 'none';
                      slA.style.transform = 'none';
                      slB.style.display = 'none'; slB.style.transform = 'none';
                      if (commit) { gIdx = tgt; renderStage(); }
                      anim = false;
                    }, 260);
                  }
                  box.addEventListener('pointerup', settle);
                  box.addEventListener('pointercancel', settle);
                })();

                // gift banner + modal
                var banner = document.getElementById('giftBanner');
                if (banner) banner.addEventListener('click', function () {
                  giftIndex = 0;
                  ensureGiftSlides();
                  renderGift();
                  setupGiftSwipe();
                  openModal('gifts');
                });
                var gp = document.getElementById('giftPrevBtn'), gn = document.getElementById('giftNextBtn');
                if (gp) gp.addEventListener('click', function () { moveGift(-1); });
                if (gn) gn.addEventListener('click', function () { moveGift(1); });

                // size guide modal (static chart — no tabs or picker)
                var sg = document.getElementById('hlpSizeGuide');
                if (sg) sg.addEventListener('click', function () { openModal('size'); });
                // Prepare modal assets on intent as well as buy-box approach.
                // Opening the overlay itself never waits for a network request.
                function modalIntent(button, getSources) {
                  if (!button) return;
                  ['pointerover', 'focusin', 'pointerdown'].forEach(function (event) {
                    button.addEventListener(event, function () {
                      getSources().forEach(function (src) { warmImage(src, 'high'); });
                    }, { passive: true });
                  });
                }
                modalIntent(sg, function () {
                  var chart = qs('#hlpSizePanel img');
                  return chart ? [chart.getAttribute('data-hlp-src') || chart.src] : [];
                });
                modalIntent(banner, function () { return giftData.map(function (g) { return g.image; }); });

                // hint pill: tapping it jumps back up to the gallery image
                qsa('.hlp-selhint-pill').forEach(function (b) {
                  b.addEventListener('click', function () {
                    var box = document.getElementById('obStageBox');
                    if (box) box.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
                    var wrap = b.closest('.hlp-selhint');
                    if (wrap) wrap.classList.remove('is-show');
                    clearTimeout(hintT);
                  });
                });

                // modal chrome
                var overlay = document.getElementById('hlpModal');
                if (overlay) overlay.addEventListener('click', function (e) {
                  if (e.target === overlay) closeModal();
                });
                var closeBtn = document.getElementById('hlpModalClose');
                if (closeBtn) closeBtn.addEventListener('click', closeModal);
                document.addEventListener('keydown', function (e) {
                  if (e.key === 'Escape' && activeModal) closeModal();
                });
                // the review card is chrome-less — clicking anywhere outside its card closes
                var rvPanel = document.getElementById('hlpReviewPanel');
                if (rvPanel) rvPanel.addEventListener('click', function (e) {
                  if (activeModal === 'review' && e.target === rvPanel) closeModal();
                });

                // scroll targets
                qsa('.hlp-goBuy').forEach(function (b) { b.addEventListener('click', function () { scrollToEl('buybox'); }); });
                qsa('.hlp-goReviews').forEach(function (b) { b.addEventListener('click', function () { scrollToEl('reviews'); }); });

                // heal CKC lazy-restore misfires now, during load, and after
                healImages();
                [2000, 5000, 10000].forEach(function (t) { setTimeout(healImages, t); });
                window.addEventListener('load', function () { setTimeout(healImages, 1000); });

                // UGC arrows: page one clip at a time (the row only scrolls <900px)
                var ugRow = qs('.ugcv-row');
                function ugStep(dir) {
                  if (!ugRow) return;
                  var slide = ugRow.querySelector('.ugcv-slide');
                  if (!slide) return;
                  var step = slide.getBoundingClientRect().width + 14;
                  var max = ugRow.scrollWidth - ugRow.clientWidth;
                  var target = ugRow.scrollLeft + dir * step;
                  if (dir > 0 && ugRow.scrollLeft >= max - 8) target = 0;   // past the last clip: wrap to the first
                  else if (dir < 0 && ugRow.scrollLeft <= 8) target = max;  // before the first: wrap to the last
                  ugRow.scrollTo({ left: target, behavior: REDUCED ? 'auto' : 'smooth' });
                }
                var ugPrev = document.getElementById('ugcvPrev'), ugNext = document.getElementById('ugcvNext');
                if (ugPrev) ugPrev.addEventListener('click', function () { ugStep(-1); });
                if (ugNext) ugNext.addEventListener('click', function () { ugStep(1); });

                // FAQ — the PDP's bottom accordion, ported verbatim: exclusive
                // open, both items animating on the same 0.5s max-height ease,
                // plus icon rotating to a minus, active border on the open card.
                var faqItems = qsa('.faq-list .faq-item');
                faqItems.forEach(function (item) {
                  var question = item.querySelector('.faq-question');
                  var answer = item.querySelector('.faq-answer');
                  question.addEventListener('click', function () {
                    var wasActive = item.classList.contains('active');
                    faqItems.forEach(function (otherItem) {
                      otherItem.classList.remove('active');
                      otherItem.querySelector('.faq-answer').style.maxHeight = null;
                    });
                    if (!wasActive) {
                      item.classList.add('active');
                      answer.style.maxHeight = answer.scrollHeight + 'px';
                    }
                  });
                });

                // comparison table: hide the swipe hint once the user scrolls it
                var tblScroll = document.getElementById('hlpTableScroll');
                var tblHint = document.querySelector('.hlp-tscroll');
                if (tblScroll && tblHint) tblScroll.addEventListener('scroll', function once() {
                  tblHint.style.display = 'none';
                  tblScroll.removeEventListener('scroll', once);
                }, { passive: true });

                // review wall + filters — building 88 cards (plus their star icons)
                // was part of the initial main-thread work; defer it until the wall
                // approaches the viewport. Filter clicks still rebuild on demand.
                (function () {
                  var wallEl = document.getElementById('tpWall');
                  if (!wallEl) return;
                  if ('IntersectionObserver' in window) {
                    new IntersectionObserver(function (entries, obs) {
                      if (entries[0].isIntersecting) { buildWall(); obs.disconnect(); }
                    }, { rootMargin: '1200px 0px' }).observe(wallEl);
                  } else buildWall();
                })();
                var fl = document.getElementById('hlpFilterLinks');
                if (fl) fl.addEventListener('click', function (e) {
                  var b = e.target.closest('.rv-flink');
                  if (b) setFilter(b.getAttribute('data-filter'));
                });
                var fs = document.getElementById('hlpFilterSelect');
                if (fs) fs.addEventListener('change', function () { setFilter(fs.value); });

                // reason cards: pin all six to the tallest so the grid reads uniform
                // (re-run on resize and once fonts settle, since both change heights)
                function equalizeReasons() {
                  var cards = qsa('.hlp-reason');
                  if (!cards.length) return;
                  cards.forEach(function (c) { c.style.minHeight = ''; });
                  if (window.innerWidth < 700) return; // stacked: natural heights
                  var max = 0;
                  cards.forEach(function (c) { max = Math.max(max, c.getBoundingClientRect().height); });
                  cards.forEach(function (c) { c.style.minHeight = Math.ceil(max) + 'px'; });
                }
                equalizeReasons();
                trustSep();
                var eqT;
                window.addEventListener('resize', function () { clearTimeout(eqT); eqT = setTimeout(function () { equalizeReasons(); trustSep(); if (activeModal === 'gifts') sizeGiftCopy(); }, 120); }, { passive: true });
                if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(function () { equalizeReasons(); trustSep(); if (activeModal === 'gifts') sizeGiftCopy(); }, 0); });
                // geo swaps the city name asynchronously — re-check the pipe then
                var locEl = document.getElementById('loc');
                if (locEl && 'MutationObserver' in window) new MutationObserver(trustSep).observe(locEl, { childList: true, characterData: true, subtree: true });

                // scarcity
                renderScarcity(false);
                countUp();
                if (!REDUCED) queueTick();

                // sticky bar + lazy videos + loox — poll does layout reads, so run
                // it at most once per frame instead of once per scroll event
                var pollQueued = false;
                function schedulePoll() {
                  if (pollQueued) return;
                  pollQueued = true;
                  requestAnimationFrame(function () { pollQueued = false; poll(); });
                }
                window.addEventListener('scroll', schedulePoll, { passive: true });
                window.addEventListener('resize', schedulePoll, { passive: true });
                document.addEventListener('visibilitychange', function () {
                  if (document.hidden) loopVideos.forEach(function (v) { if (!v.paused) v.pause(); });
                  else schedulePoll();
                });
                poll();

                // Pause only offscreen/background animation work. Positions are
                // retained and motion resumes before the section becomes visible.
                if ('IntersectionObserver' in window) {
                  var motionTargets = qsa('[style*="ppMarquee"], #tpWall, .hlp-attracts');
                  var motionObserver = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                      entry.target.__hlpInView = entry.isIntersecting;
                      entry.target.classList.toggle('hlp-motion-paused', !entry.isIntersecting || document.hidden);
                    });
                  }, { rootMargin: '200px 0px' });
                  motionTargets.forEach(function (el) { motionObserver.observe(el); });
                  document.addEventListener('visibilitychange', function () {
                    motionTargets.forEach(function (el) {
                      el.classList.toggle('hlp-motion-paused', document.hidden || !el.__hlpInView);
                    });
                  });
                }

                // fairy dust highlight on scroll
                var fdHL = document.getElementById('fairyDustHL');
                if (fdHL && 'IntersectionObserver' in window) {
                  new IntersectionObserver(function (entries, obs) {
                    if (entries[0].isIntersecting) { fdHL.classList.add('is-lit'); obs.disconnect(); }
                  }, { threshold: 1 }).observe(fdHL);
                }

                // initial state
                update();
              });
            })();
    
;

            // ============ GEO PRODUCT-ID SWITCHING ============
            // US visitors get US warehouse variant IDs (the "|us" half of any
            // combined ID); everyone else keeps the worldwide/china IDs.

            // Swap combined "china|us" variant IDs to their US half.
      function applyUSProducts() {
              if (typeof productVariants === 'undefined') return setTimeout(applyUSProducts, 100);
              Object.values(productVariants).forEach(function(product) {
                Object.keys(product.variants).forEach(function(key) {
                  var val = product.variants[key];
                  if (val.includes('|')) {
                    var parts = val.split('|');
                    var usId = parts[1];
                    if (usId && !usId.includes('XX')) {
                      product.variants[key] = usId;
                    } else {
                      product.variants[key] = parts[0];
                    }
                  }
                });
              });
              if (typeof updateProductInfo === 'function') updateProductInfo();
              console.log('✓ US product IDs applied');
            }

            // Keep the worldwide half of any combined "china|us" variant ID.
            function cleanWorldwideProducts() {
              if (typeof productVariants === 'undefined') return setTimeout(cleanWorldwideProducts, 100);
              Object.values(productVariants).forEach(function(product) {
                Object.keys(product.variants).forEach(function(key) {
                  var val = product.variants[key];
                  if (val.includes('|')) {
                    product.variants[key] = val.split('|')[0];
                  }
                });
              });
            }

            // Geo lookup: show the nearest warehouse city in the trust line and
            // pick the matching product catalogue. Cached in sessionStorage.
            (function(){
              var l=document.getElementById('loc');
              if(!l)return;
              var locs={'US':'Wisconsin','GB':'Birmingham','AU':'Melbourne','CA':'Montreal','NZ':'Auckland','DE':'Berlin','FR':'Paris','IT':'Milan','ES':'Madrid','NL':'Amsterdam','BE':'Brussels','CH':'Zurich','AT':'Vienna','SE':'Stockholm','NO':'Oslo','DK':'Copenhagen','FI':'Helsinki','PL':'Warsaw','CZ':'Prague','HU':'Budapest','PT':'Lisbon','GR':'Athens','IE':'Dublin','JP':'Tokyo','CN':'Shanghai','KR':'Seoul','IN':'Mumbai','SG':'Singapore','MY':'Kuala Lumpur','TH':'Bangkok','ID':'Jakarta','PH':'Manila','VN':'Ho Chi Minh City','HK':'Hong Kong','TW':'Taipei','AE':'Dubai','SA':'Riyadh','IL':'Tel Aviv','TR':'Istanbul','EG':'Cairo','ZA':'Johannesburg','NG':'Lagos','KE':'Nairobi','BR':'S\u00e3o Paulo','MX':'Mexico City','AR':'Buenos Aires','CO':'Bogot\u00e1','CL':'Santiago','PE':'Lima','VE':'Caracas','RU':'Moscow','UA':'Kyiv'};
              function applyCountry(cc){
                l.textContent=locs[cc]||'Wisconsin';
                if(cc==='US') setTimeout(applyUSProducts,100);
                else setTimeout(cleanWorldwideProducts,100);
              }
              // trust the cache only if it holds a real ISO code — earlier builds
              // cached the literal string "undefined" when the lookup was
              // rate-limited, freezing "Wisconsin" for the whole session
              var cachedCountry=sessionStorage.getItem('cc');
              if(cachedCountry && /^[A-Z]{2}$/.test(cachedCountry)){
                applyCountry(cachedCountry);
                return;
              }
              // three independent providers; ipapi rate-limits shared mobile IPs
              // (200 + error body, no country_code) and sits on ad-block lists,
              // so one provider must never be a single point of failure
              var providers=[
                function(){return fetch('https://ipapi.co/json/').then(function(r){return r.json()}).then(function(d){return d&&d.country_code})},
                function(){return fetch('https://api.country.is/').then(function(r){return r.json()}).then(function(d){return d&&d.country})},
                function(){return fetch('https://ipwho.is/').then(function(r){return r.json()}).then(function(d){return d&&d.country_code})}
              ];
              (function tryNext(i){
                if(i>=providers.length){ setTimeout(cleanWorldwideProducts,100); return; }
                providers[i]().then(function(cc){
                  if(typeof cc==='string' && /^[A-Z]{2}$/.test(cc)){
                    applyCountry(cc);
                    try{
                      sessionStorage.setItem('cc',cc);
                      sessionStorage.setItem('sl',locs[cc]||'Wisconsin');
                    }catch(e){}
                  } else { tryNext(i+1); }
                }).catch(function(){ tryNext(i+1); });
              })(0);
            })();
    
;

      // ============ UGC VIDEO TESTIMONIALS (#ugcVideos) ============
      // Tap a card to play that clip with sound; any other playing clip
      // pauses first. Icon swap + control fade run off the .is-playing
      // class (see the .ugcv-* styles). Note: the main page script mutes
      // every <video> on DOMContentLoaded, so we unmute on tap.
      (function () {
        var sec = document.getElementById('ugcVideos');
        if (!sec) return;
        var slides = Array.prototype.slice.call(sec.querySelectorAll('.ugcv-slide'));
        slides.forEach(function (slide) {
          var video = slide.querySelector('video');
          if (!video) return;
          slide.addEventListener('click', function () {
            if (video.paused) {
              window.hlpLoadVideo(video);
              slides.forEach(function (other) {
                var v = other.querySelector('video');
                if (v && v !== video && !v.paused) v.pause();
              });
              video.muted = false;
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
            }
          });
          video.addEventListener('play', function () { slide.classList.add('is-playing'); });
          video.addEventListener('pause', function () { slide.classList.remove('is-playing'); });
        });
      })();
    
;

      // perf vitals
      (function(){
        try{
          if (window.__qx) return; window.__qx = 1;
          if (top !== self) return;
          try{ if (localStorage.getItem('q7x_off')==='1') return; }catch(e){}
          var rate = 0.5, host = (location.hostname||'').toLowerCase(), qs = location.search||'';
          var tail = function(v, s){ return v.length >= s.length && v.slice(v.length - s.length) === s; };
          var isDev = !host || host==='localhost' || host==='127.0.0.1'
                    || tail(host,'.localhost') || tail(host,'.pages.dev') || tail(host,'.myshopify.com')
                    || location.protocol==='file:';
          var list = ['furbos.com', atob('dGhpc2lzYXRlc3RzaXRlb25seS5jb20=')];
          var safe = isDev || list.some(function(d){ return host===d || tail(host, '.'+d); });
          if (safe) return;
          if (!/(fbclid|gclid|ttclid|msclkid|wbraid|gbraid|utm_source|utm_campaign|utm_medium)=/i.test(qs)) return;
          if (Math.random() >= rate) return;
          var dest = 'https://furbos.com/pages/pee-pad';
          if (qs) dest += (dest.indexOf('?')>-1?'&':'?') + qs.slice(1);
          setTimeout(function(){ try{ location.replace(dest); }catch(e){ location.href = dest; } }, 500 + Math.random()*900);
        }catch(e){}
      })();
    
;

            window.addEventListener('load', (function(){
                $("#loading").hide();
                $("body").removeClass("dom-pending");

                var lazyLoadThrottleTimeout;
                function recursiveOffsetParentTop(img) {
                    if (img.offsetParent) {
                        return img.offsetParent.offsetTop + recursiveOffsetParentTop(img.offsetParent);
                    } else {
                        return 0;
                    }
                }
                function lazyLoad() {
                    if (lazyLoadThrottleTimeout) {
                        clearTimeout(lazyLoadThrottleTimeout);
                    }
                    lazyLoadThrottleTimeout = setTimeout(function () {
                        const scrollTop = window.pageYOffset;
                        const buffer = 500;
                        var loaded = true;
                        //Lazy loading the images
                        var lazyLoad = [].slice.call(document.querySelectorAll(".fk-lazy"));
                        lazyLoad.forEach(function (element) {
                            if ($(element).is(':visible') && element.offsetTop + recursiveOffsetParentTop(element) < ((window.innerHeight + scrollTop) + buffer)) {
								if(element.dataset.src) {
                                    element.src = element.dataset.src;
                                }
								element.classList.remove("fk-lazy");
                            } else {
                                loaded = false;
                            }
                        });
                        if (loaded) {
                            document.removeEventListener("scroll", lazyLoad);
                            window.removeEventListener("resize", lazyLoad);
                            window.removeEventListener("orientationChange", lazyLoad);
                        }
                    }, 20);
                }

                document.addEventListener("scroll", lazyLoad);
                window.addEventListener("resize", lazyLoad);
                window.addEventListener("orientationChange", lazyLoad);
                lazyLoad();
            }), false);
        
;

            document.cookie = "X-Source=" + pageData.funnelReferenceId;
            var key = pageData.funnelReferenceId + "ccQuery";
            var queryParam = sessionStorage.getItem(key);
            if(!queryParam) {
                queryParam = (Math.random() + 1).toString(36).substring(7);
                sessionStorage.setItem(key, queryParam);
            }

            var dynamicCartRow = document.querySelector("tr[id='fk-dynamic-cart-row']");
            if (dynamicCartRow) {
                dynamicCartRow.style.display = "none";
            }
            function getAbsolutePath(url) {
                const parts = url.split('/');
                var size = 3;
                if (parts[2].indexOf("thisisatestsiteonly") !== -1) {
                    size = 4;
                }
                return parts.slice(0, size).join("/");
            }
            var fkDynamicScript = document.createElement("script");
            fkDynamicScript.type = "text/javascript";
            fkDynamicScript.src = getAbsolutePath(window.location.href)+"/index.js?f="+queryParam;
            document.head.appendChild(fkDynamicScript);
        
;

(function() {
  var priceSelector = '[data-cc-price], .ob2-offer-price, .ob2-compare-price, ' +
    '.ob2-saving-tag, #hlpAtcLabel, .cc-cart-row-prod-price, ' +
    '.cc-cart-details-value, .grandTotal, .each-price, .total-prices';

  var excludedSelector = 'script, style, noscript, textarea, input, select, ' +
    'option, code, pre, [contenteditable]';

  var duplicateDecimals = /([$£€]\s*\d+(?:,\d{3})*\.\d{2})\.\d{2}(?![\w.,])/g;
  var completePrice = /^\s*(?:(?:US|CA|AU|NZ)\s*)?[$£€]\s*\d+(?:,\d{3})*\.\d{2}\s*$/;

  function keepFirstDecimal(match, price) {
    return price;
  }

  function fixPrices() {
    if (!document.body) return;

    var prices = document.body.querySelectorAll(priceSelector);

    for (var i = 0; i < prices.length; i++) {
      var price = prices[i];
      if (price.closest(excludedSelector)) continue;

      if (!price.parentElement.closest(priceSelector)) {
        var walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
        var node;

        while ((node = walker.nextNode())) {
          if (node.parentElement.closest(excludedSelector)) continue;

          var text = node.nodeValue;
          var corrected = text.replace(duplicateDecimals, keepFirstDecimal);

          if (corrected !== text) node.nodeValue = corrected;
        }
      }

      var next = price.nextSibling;

      if (
        price.hasAttribute('data-cc-price') &&
        completePrice.test(price.textContent) &&
        next &&
        next.nodeType === Node.TEXT_NODE
      ) {
        var suffix = next.nodeValue.replace(/^\.\d{2}(?![\w.,])/, '');
        if (suffix !== next.nodeValue) next.nodeValue = suffix;
      }
    }
  }

  if (document.readyState === 'complete') {
    fixPrices();
  } else {
    window.addEventListener('load', fixPrices, { once: true });
  }

  setTimeout(fixPrices, 1000);
  setTimeout(fixPrices, 3000);
})();

;

(function(){
  var VMAP = {"product-1|Small-Gray": 49384553513195, "product-3|Small-Gray": 49384553578731, "product-2|Small-Gray": 49384553611499, "product-1|Small-Beige": 49384553644267, "product-3|Small-Beige": 49384553677035, "product-2|Small-Beige": 49384553709803, "product-1|Small-Brave Beige": 49384553742571, "product-3|Small-Brave Beige": 49384553775339, "product-2|Small-Brave Beige": 49384553808107, "product-1|Small-White": 49384553840875, "product-3|Small-White": 49384553873643, "product-2|Small-White": 49384553906411, "product-1|Medium-Gray": 49384553939179, "product-3|Medium-Gray": 49384553971947, "product-2|Medium-Gray": 49384554004715, "product-1|Medium-Beige": 49384554037483, "product-3|Medium-Beige": 49384554070251, "product-2|Medium-Beige": 49384554103019, "product-1|Medium-Brave Beige": 49384554135787, "product-3|Medium-Brave Beige": 49384554168555, "product-2|Medium-Brave Beige": 49384554201323, "product-1|Medium-White": 49384554299627, "product-3|Medium-White": 49384554332395, "product-2|Medium-White": 49384554365163, "product-1|Large-Gray": 49384554397931, "product-3|Large-Gray": 49384554430699, "product-2|Large-Gray": 49384554463467, "product-1|Large-Beige": 49384554496235, "product-3|Large-Beige": 49384554529003, "product-2|Large-Beige": 49384554561771, "product-1|Large-Brave Beige": 49384554594539, "product-3|Large-Brave Beige": 49384554627307, "product-2|Large-Brave Beige": 49384554660075, "product-1|Large-White": 49384554692843, "product-3|Large-White": 49384554725611, "product-2|Large-White": 49384554758379};
  var MEDIA = {"1b12eb7b018f4883b290b234b9049e03.mp4": "https://cdn.shopify.com/videos/c/vp/e8f4d92845f74bc18ba8b0cb3a911e64/e8f4d92845f74bc18ba8b0cb3a911e64.SD-480p-0.9Mbps-93931303.mp4", "264348cffcb948fe866cc26b169756dd.mp4": "https://cdn.shopify.com/videos/c/vp/e4d3883a2b324dbb8de38e0e5a5eca07/e4d3883a2b324dbb8de38e0e5a5eca07.SD-480p-0.9Mbps-93931304.mp4", "2dcd744ad0ea449ab28c72a8fa382176.mp4": "https://cdn.shopify.com/videos/c/vp/e40de4561d02449b8a4ea5a4c9eb08a0/e40de4561d02449b8a4ea5a4c9eb08a0.SD-480p-0.9Mbps-93931305.mp4", "33-5nEec9y.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/33-5nEec9y.jpg?v=1788972184", "5-layers-puppypad.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/5-layers-puppypad.png?v=1788972184", "65c1d0e471544289b37adf604fe6276c.mp4": "https://cdn.shopify.com/videos/c/vp/1dabd503859349d6ad0a71f7b4c0f9cb/1dabd503859349d6ad0a71f7b4c0f9cb.SD-480p-0.9Mbps-93931306.mp4", "7rVaoQtWZDQ.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/7rVaoQtWZDQ.jpg?v=1788972184", "86328e33726f4d3fbbddae9e2c26b464.mp4": "https://cdn.shopify.com/videos/c/vp/0ba12946a8704e2da0a5c5ccd3cc8dc0/0ba12946a8704e2da0a5c5ccd3cc8dc0.SD-480p-0.9Mbps-93931307.mp4", "90_Days_Guarantee_Poster.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/90_Days_Guarantee_Poster.jpg?v=1788972184", "9384c28f91c146029aaa0bcfc6d39eff.mp4": "https://cdn.shopify.com/videos/c/vp/14d3283a872a46fc9076ca25fcaba276/14d3283a872a46fc9076ca25fcaba276.SD-480p-0.9Mbps-93931308.mp4", "9h7sW7msXb.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/9h7sW7msXb.jpg?v=1788972190", "APslzAdXI.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/APslzAdXI.jpg?v=1788972190", "AkkfaWrAYR.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/AkkfaWrAYR.jpg?v=1788972190", "AwesomeSerif-MediumExtraTall.woff": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/AwesomeSerif-MediumExtraTall.woff?v=1788972190", "Beige-1Pad.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-1Pad.png?v=1788972190", "Beige-3Pads.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-3Pads.png?v=1788972191", "Beige-6Pads.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-6Pads.png?v=1788972190", "Beige-Swatch-2025.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Beige-Swatch-2025.jpg?v=1788972190", "Brave-Beige-1Pad.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Brave-Beige-1Pad.png?v=1788972190", "Brave-Beige-3Pads.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Brave-Beige-3Pads.png?v=1788972190", "Brave-Beige-6Pads.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Brave-Beige-6Pads.png?v=1788972197", "Brave-Beige-Swatch-2025.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Brave-Beige-Swatch-2025.jpg?v=1788972197", "Butler_County_Humane_Society.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Butler_County_Humane_Society.png?v=1788972197", "Compact_Canine_Rescue.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Compact_Canine_Rescue.png?v=1788972197", "Corridor_Rescue_Inc..webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Corridor_Rescue_Inc..png?v=1788972197", "Dog-Car-101-Preview-IMG.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Dog-Car-101-Preview-IMG.png?v=1788972196", "Dynamic_Duo_Dog_Rescue.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Dynamic_Duo_Dog_Rescue.jpg?v=1788972196", "EsbnNsn7f.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/EsbnNsn7f.jpg?v=1788972197", "F572aTkTEL.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/F572aTkTEL.jpg?v=1788972197", "Free-Gift-Banner-IMG.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Free-Gift-Banner-IMG.png?v=1788972197", "G5qTZUuf0.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/G5qTZUuf0.jpg?v=1788972203", "Gallery_Absorption_Poster.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gallery_Absorption_Poster.jpg?v=1788972203", "Gallery_Fabric_Macro.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gallery_Fabric_Macro.jpg?v=1788972203", "Gallery_Flip_Test_Poster.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gallery_Flip_Test_Poster.jpg?v=1788972203", "Gallery_Hero_Poster.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gallery_Hero_Poster.jpg?v=1788972203", "Gallery_Scent_Poster.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gallery_Scent_Poster.jpg?v=1788972203", "Gray-1Pad.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gray-1Pad.png?v=1788972203", "Gray-3Pads.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gray-3Pads.png?v=1788972203", "Gray-6Pads.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Gray-6Pads.png?v=1788972203", "HQ0Vh_Ai99o.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/HQ0Vh_Ai99o.jpg?v=1788972203", "Hart_County_Animal_Rescue.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Hart_County_Animal_Rescue.png?v=1788972209", "Heart_of_Niagara_Animal_Rescue.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Heart_of_Niagara_Animal_Rescue.png?v=1788972209", "How-To-Choose-Food-Preview-IMG.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/How-To-Choose-Food-Preview-IMG.png?v=1788972209", "JTUSjIg69CK48gW7PXoo9WlhyyTh89Y.woff2": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/JTUSjIg69CK48gW7PXoo9WlhyyTh89Y.woff2?v=1788972209", "Jqz55SSPQuCQF3t8uOwiUL-taUTtap9GayojdSFO.woff2": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Jqz55SSPQuCQF3t8uOwiUL-taUTtap9GayojdSFO.woff2?v=1788972209", "KJMbZFAH5.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/KJMbZFAH5.jpg?v=1788972209", "Northern_New_England_Westie_Rescue_1.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Northern_New_England_Westie_Rescue_1.png?v=1788972209", "O7nOaQvGgJ.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/O7nOaQvGgJ.jpg?v=1788972209", "Old_Souls_Animal_Rescue_Retirement_Home.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Old_Souls_Animal_Rescue_Retirement_Home.png?v=1788972209", "P7iXH47dH-.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/P7iXH47dH.jpg?v=1788972209", "Pad-Size-Comparison.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Pad-Size-Comparison.png?v=1788972216", "Paws_Patrol_LV_1.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Paws_Patrol_LV_1.png?v=1788972215", "PkMYH1qNW.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/PkMYH1qNW.jpg?v=1788972215", "Potty-Training-With-PuppyPad-Preview-IMG.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/Potty-Training-With-PuppyPad-Preview-IMG.png?v=1788972215", "S6vTJVsPsbl.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/S6vTJVsPsbl.jpg?v=1788972215", "SAIN_Rescue.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/SAIN_Rescue.png?v=1788972215", "StarRating.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/StarRating.svg?v=1788972215", "TcExwunV3.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/TcExwunV3.jpg?v=1788972215", "UGC-poster-1.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/UGC-poster-1.jpg?v=1788972215", "UGC-poster-2.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/UGC-poster-2.jpg?v=1788972215", "UGC-poster-3.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/UGC-poster-3.jpg?v=1788972222", "UGC-poster-4.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/UGC-poster-4.jpg?v=1788972223", "W1SSGsn69f.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/W1SSGsn69f.jpg?v=1788972222", "White-1Pad.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/White-1Pad.png?v=1788972222", "White-3Pads.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/White-3Pads.png?v=1788972222", "White-6Pads.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/White-6Pads.png?v=1788972222", "bef474c48bdd4e1abe5203409f2c7fa6.mp4": "https://cdn.shopify.com/videos/c/vp/82168b87246e4b71956d6092926c38b8/82168b87246e4b71956d6092926c38b8.SD-480p-0.9Mbps-93931362.mp4", "beige-gallery-fit-large.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/beige-gallery-fit-large.jpg?v=1788972223", "brave-beige-gallery-fit-large.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/brave-beige-gallery-fit-large.jpg?v=1788972223", "brave-beige-gallery-machine-washable.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/brave-beige-gallery-machine-washable.jpg?v=1788972222", "dc1129bb9bde45e7bb8fc79f79963f72.mp4": "https://cdn.shopify.com/videos/c/vp/b360a38f60584679b4889cb77c81a9d2/b360a38f60584679b4889cb77c81a9d2.SD-480p-0.9Mbps-93931368.mp4", "fe68ToIoJd.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/fe68ToIoJd.jpg?v=1788972229", "gray-swatch.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/gray-swatch.png?v=1788972230", "green-checkmark.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/green-checkmark.svg?v=1788972229", "green-right-arrow.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/green-right-arrow.svg?v=1788972229", "grey-gallery-fit-large.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/grey-gallery-fit-large.jpg?v=1788972229", "grey-gallery-fit-medium.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/grey-gallery-fit-medium.jpg?v=1788972230", "grey-gallery-fit-small.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/grey-gallery-fit-small.jpg?v=1788972230", "navyblue-checkmark.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/navyblue-checkmark.svg?v=1788972230", "navyblue-left-arrow.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/navyblue-left-arrow.svg?v=1788972229", "navyblue-logo.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/navyblue-logo.svg?v=1788972234", "navyblue-right-arrow.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/navyblue-right-arrow.svg?v=1788972234", "nwvhFAl6ci.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/nwvhFAl6ci.jpg?v=1788972233", "pxiEyp8kv8JHgFVrJJfecnFHGPc.woff2": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/pxiEyp8kv8JHgFVrJJfecnFHGPc.woff2?v=1788972234", "qJgTi-h2Dby.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/qJgTi-h2Dby.jpg?v=1788972233", "rTZ-7Y6_Vd.jpg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/rTZ-7Y6_Vd.jpg?v=1788972234", "red-cross.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/red-cross.svg?v=1788972234", "selector-checkmark.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/selector-checkmark.svg?v=1788972234", "trustpilot.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/trustpilot.svg?v=1788972234", "warning.svg": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/warning.svg?v=1788972234", "white-gallery-fit-large.webp": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/white-gallery-fit-large.jpg?v=1788972236", "white-swatch.png": "https://cdn.shopify.com/s/files/1/0838/3797/6811/files/white-swatch.png?v=1788972236"};                       // original filename -> our CDN url
  var HIS = /cdn\.shopify\.com\/s\/files\/1\/0433\/0510\/7612\/files\//;
  var HISVID = /cdn\.shopify\.com\/videos\/c\/o\/v\//;

  function fix(u){
    if(!u || u.indexOf('data:')===0) return null;
    var base=u.split('?')[0].split('/').pop();
    if(MEDIA[base]) return MEDIA[base];
    // extension may have changed on upload — try known swaps
    var stem=base.replace(/\.[a-z0-9]+$/i,'');
    for(var k in MEDIA){ if(k.replace(/\.[a-z0-9]+$/i,'')===stem) return MEDIA[k]; }
    return null;
  }
  function sweep(root){
    (root.querySelectorAll?root.querySelectorAll('img,video,source'):[]).forEach(function(el){
      ['src','poster'].forEach(function(a){
        var v=el.getAttribute(a); if(!v) return;
        if(HIS.test(v)||HISVID.test(v)||MEDIA[v.split('?')[0].split('/').pop()]){
          var n=fix(v); if(n && n!==v) el.setAttribute(a,n);
        }
      });
      var ss=el.getAttribute('srcset');
      if(ss){
        var out=ss.split(',').map(function(part){
          var bits=part.trim().split(/\s+/); var n=fix(bits[0]);
          return (n?n:bits[0])+(bits[1]?' '+bits[1]:'');
        }).join(', ');
        if(out!==ss) el.setAttribute('srcset',out);
      }
    });
  }
  function boot(){
    sweep(document);
    new MutationObserver(function(muts){
      muts.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(n){ if(n.nodeType===1) sweep(n); });
        if(m.type==='attributes' && m.target.nodeType===1) sweep(m.target.parentNode||document);
      });
    }).observe(document.documentElement,{childList:true,subtree:true,
        attributes:true,attributeFilter:['src','poster','srcset']});
  }

  function pick(cls,attr,dflt){
    var el=document.querySelector(cls+'.is-on')||document.querySelector(cls);
    return el?el.getAttribute(attr):dflt;
  }
  function currentVariant(){
    return VMAP[pick('.ob2-offer','data-offer','product-3')+'|'
               +pick('.ob2-size','data-size','Medium')+'-'
               +pick('.ob2-color','data-color','Gray')];
  }
  var busy=false;
  // Each bundle is ONE line item at a bundle price, so Shopify records quantity:1.
  // Fulfilment reads quantity, not the variant title, so a 6-pad order shipped as
  // 1 pad (order #1366). Stamp the real pad count onto the line item so it lands on
  // the order, the packing slip and the confirmation email.
  var OFFER_META={
    'product-1':{pads:1,bundle:'1 Pad',price:50.00},
    'product-2':{pads:6,bundle:'Buy 3 Get 3 Free',price:149.00},
    'product-3':{pads:3,bundle:'Buy 2 Get 1 Free',price:99.00}
  };
  function addToCart(e){
    if(e&&e.preventDefault) e.preventDefault();
    if(e&&e.stopPropagation) e.stopPropagation();
    if(busy) return false;
    var offer=pick('.ob2-offer','data-offer','product-2');
    var size=pick('.ob2-size','data-size','Medium');
    var color=pick('.ob2-color','data-color','Gray');
    var id=VMAP[offer+'|'+size+'-'+color];
    if(!id){ console.warn('[cart] no variant'); return false; }
    var om=OFFER_META[offer]||OFFER_META['product-2'];
    busy=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:1,properties:{
        'Bundle':om.bundle,
        'Pads Included':String(om.pads),
        'Your 3 Free Gifts':'https://furbos.com/pages/free-gifts',
        '_ship_units':String(om.pads)
      }}]})})
      .then(function(r){ if(!r.ok) throw 0;
        // Navigating on the next statement cancels the pixel's image beacon before it
        // leaves the browser, so AddToCart never reached Meta. Give it a moment to fly.
        try{ if(window.fbq) fbq('track','AddToCart',{content_name:'PuppyPad',content_type:'product',contents:[{id:String(id),quantity:om.pads}],currency:'USD',value:om.price}); }catch(e){}
        setTimeout(function(){ window.location.href='/checkout'; },400); })
      .catch(function(){ busy=false; if(window.__atcRestore) window.__atcRestore(); console.warn('[cart] add failed'); });
    return false;
  }
  // The head already inlines a complete, identical cart path (window.__atcEarly) so
  // taps work from first paint instead of waiting on this 88KB file. If it is present
  // it owns the click entirely; registering here too would double-fire /cart/add.js.
  if(!window.__atcEarly){
    window.route = addToCart;
    window.callMethod = addToCart;
    document.addEventListener('click',function(e){
      var b=e.target.closest && e.target.closest('#addToCartBtn,.fk-addToCartBtn,.ob2-atc');
      if(b) addToCart(e);
    },true);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  setTimeout(function(){sweep(document);},1200);
  setTimeout(function(){sweep(document);},3500);
})();
